<template>
    <!-- 整页根容器固定为视口大小并裁掉溢出：
         窗口高度变化时只允许「分类列表 / 话术列表」内部滚动，整页不再出现滚动条 -->
    <div class="homePage">
        <login-dialog v-if="loginDailogShow" @hide="loginDailogClick" />
        <!-- 备忘提醒 App内横幅 -->
        <div v-if="memoReminderBanner" class="memoRemindBanner"
            :style="{'top':(($common.isElectron()?32:0)+8)+'px'}" @click="memoBannerClick">
            <svg class="memoRemindBannerIcon" viewBox="0 0 24 24" width="18" height="18">
                <path fill="currentColor"
                    d="M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z" />
            </svg>
            <div class="memoRemindBannerBody">
                <div class="memoRemindBannerTitle">备忘提醒 {{memoReminderBanner.remindText}}</div>
                <div class="memoRemindBannerContent">{{memoReminderBanner.content}}</div>
            </div>
            <div class="memoRemindBannerClose" @click.stop="memoBannerClose">×</div>
        </div>
        <div class="top" :style="{'height':((tabIndex==0||tabIndex==1)&&!xiaoguanShow)?'74px':'32px'}">
            <div class="topSubP" ref="topSubP">
                <div class="topSub">
                    <div class="topLLP" ref="topLLP">
                        <template v-for="(tab, ti) in topTabOrder">
                            <div :key="tab.key"
                                :class="topTabItemClass(tab)"
                                :style="topTabDragStyle(tab)"
                                @click="topTabClick(tab)"
                                @mousedown="onTopTabMouseDown($event, tab)">
                                <span>{{ tab.label }}</span>
                                <div v-if="topTabIsActive(tab)"></div>
                            </div>
                            <div :key="tab.key + '-line'" class="topLLItemLine" v-if="ti < topTabOrder.length - 1"></div>
                        </template>
                    </div>
                    <div class="topRP">
                        <div class="topRP">
                            <!-- 文案库(tabIndex==1)的“当前文案包 + 切换文案包”已下移到单独一行 -->
                            <div class="topRR2" @click="loginDailogClick" >
                                <img v-if="faceIcon&&faceIcon.length" class="header-main-top" :src="faceIcon"/>
                                <img v-else class="header-main-top"
                                    src="https://imagessl.edujia.com/A-1ed71af7_20230804094317.png"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="tabIndex===0 && !xiaoguanShow" class="searchArea">
                <div class="searchAreaLeft">
                    <img v-if="isSeaching" class="searchBackBtn" src="https://imagessl.edujia.com/A-1ed71af7_20230804162525.png"  @click="cancelSearch"/>
                    <div class="searchAreaBar">
                        <img src="https://imagessl.edujia.com/A-1ed71af7_20240219112835.png" />
                        <input v-model="keywords" placeholder="输入关键词搜索" type="text" />
                    </div>
                    <div class="searchAreaBtn" @click="searchBtnClick">搜索</div>
                    <!-- <div v-if="!isSeaching" class="searchAreaBtn" @click="searchBtnClick">搜索</div> -->
                    <!-- <div v-else class="searchAreaBtn searchAreaCancelBtn" @click="searchBtnClick">取消</div> -->
                </div>
                <!-- 右半边：当前团队 + 切换团队 -->
                <div v-if="huashuTeamList.length" class="searchAreaTeam">
                    <div class="topL">
                        <img v-if="huashuTeamList[teamSelIdx].roleId==2" class="topLL"
                            src="https://imagessl.edujia.com/A-1ed71af7_20230804094647.png">
                        <div class="topLR">{{huashuTeamList[teamSelIdx].showName}}</div>
                    </div>
                    <div class="topR">
                        <img class="topRL" src="https://imagessl.edujia.com/A-1ed71af7_20230804095245.png"
                            @click="changeTeam">
                        <div class="topRR" @click="changeTeam">切换团队</div>
                    </div>
                </div>
            </div>
            <!-- 文案库：文案包切换单独一行，靠右显示 -->
            <div v-if="tabIndex===1 && !xiaoguanShow" class="themeSwitchRow">
                <div v-if="themeList.length" class="topL">
                    <div class="topLR">{{themeList[themeSelIdx].title}}</div>
                </div>
                <div class="topR">
                    <img class="topRL" src="https://imagessl.edujia.com/A-1ed71af7_20230804095245.png"
                        @click="changeTeam">
                    <div class="topRR" @click="changeTeam">切换文案包</div>
                </div>
            </div>
        </div>
        <div v-if="teamListShow" class="teamListCover">
            <div class="teamListP">
                <div v-if="tabIndex==0" class="teamList">
                    <div v-for="(item,idx) in huashuTeamList"
                        :key="'huashuTeamListItem'+idx"
                        :class="idx==teamSelIdx?'teamListItemSel teamListItem':'teamListItem'"
                        @click="teamItemClick(idx)">
                        <img v-if="item.roleId==1" src="https://imagessl.edujia.com/A-1ed71af7_20231025160408.png" />
                        <img v-else-if="item.roleId==2"
                            src="https://imagessl.edujia.com/A-1ed71af7_20231025160621.png" />
                        <div>{{item.showName}}</div>
                    </div>
                </div>
                <div v-else-if="tabIndex==1" class="teamList">
                    <div v-for="(item,idx) in themeList"
                        :key="'themeListItem'+idx"
                        :class="idx==themeSelIdx?'teamListItemSel teamListItem':'teamListItem'"
                        @click="themeItemClick(idx)">
                        <!-- <img v-if="item.roleId==1" src="https://imagessl.edujia.com/A-1ed71af7_20231025160408.png"/>
                        <img v-else-if="item.roleId==2" src="https://imagessl.edujia.com/A-1ed71af7_20231025160621.png"/> -->
                        <div>{{item.title}}</div>
                    </div>
                </div>
            </div>
            <div class="shouqiBtnP">
                <div class="shouqiBtn" @click="hideTeamList">收起<img
                        src="https://imagessl.edujia.com/A-1ed71af7_20230807152925.png" /></div>
            </div>
        </div>
        <div class="content"
            :class="{'contentNoSearchTop':xiaoguanShow||(tabIndex!=0&&tabIndex!=1),'contentWithBottomBar':tabIndex==0&&!xiaoguanShow}">
            <!-- 销冠键盘页签：与其他页签一致，占满顶部 tab 栏以下的整个内容区，
                 不再用浮层，避免切换过来时还露出上一个页签的内容 -->
            <div v-if="xiaoguanShow" class="xiaoguanPanel">
                <div class="xkTopBar">
                    <div class="xkInputP" v-if="xkSegmentTab === 0">
                        <input class="xkInput xkQuestionInput" type="text" placeholder="点击粘贴问题"
                            v-model="xiaoguanQuestion" @focus="onQuestionInputFocus" @paste="onPasteQuestion" />
                        <div class="xkUploadBtn" :class="{ 'xkUploadBtnLoading': xkOcrLoading }"
                            title="上传截图识别文字" @click="uploadScreenshot">
                            <div v-if="xkOcrLoading" class="xkUploadSpinner"></div>
                            <svg v-else viewBox="0 0 24 24" width="18" height="18">
                                <path fill="currentColor"
                                    d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z" />
                            </svg>
                        </div>
                        <input ref="xkScreenshotFile" type="file" accept="image/*" style="display:none"
                            @change="onScreenshotChange" />
                    </div>
                    <div class="xkInputP xkInputHint" v-else>
                        <span>选择下方场景，生成开场白</span>
                    </div>
                    <div class="xkCheckboxP">
                        <div :class="['xkCheckboxItem', xkSelProduct ? 'xkCheckboxItemSel' : '']" @click="openProductDialog">
                            <span>{{ xkSelProduct || '切换产品' }}</span>
                            <img class="xkArrowIcon" src="https://imagessl.edujia.com/A-1ed71af7_20230807152925.png" />
                        </div>
                        <div :class="['xkCheckboxItem', xkSelTeamIdx >= 0 ? 'xkCheckboxItemSel' : '']" @click="openHuashuSelectDialog" v-if="xkSegmentTab === 0">
                            <span>{{ xkSelTeamIdx >= 0 ? huashuTeamList[xkSelTeamIdx].showName : '话术选择' }}</span>
                            <img class="xkArrowIcon" src="https://imagessl.edujia.com/A-1ed71af7_20230807152925.png" />
                        </div>
                    </div>
                </div>
                <div class="xkSegmentBar">
                    <div :class="['xkSegmentTab', xkSegmentTab===0 ? 'xkSegmentTabSel' : '']"
                        @click="xkSegmentTab = 0; xkCategorySelIdx = -1">销冠帮回</div>
                    <div :class="['xkSegmentTab', xkSegmentTab===1 ? 'xkSegmentTabSel' : '']"
                        @click="xkSegmentTab = 1; xkCategorySelIdx = -1">开场白</div>
                </div>
                <div class="teamListP">
                    <div class="teamList xkCategoryList">
                        <div v-for="(item,idx) in xkCurrentCategoryList" :key="'xkCategory'+idx"
                            :class="idx==xkCategorySelIdx?'teamListItemSel teamListItem xkCategoryItem':'teamListItem xkCategoryItem'"
                            @click="xkCategoryClick(idx)">
                            <div>{{item.label}}</div>
                        </div>
                    </div>
                </div>
                <div v-if="xkCategoryLoading" class="xkLoadingMask">
                    <div class="xkLoadingCard">
                        <div class="xkLoadingSpinner"></div>
                        <div class="xkLoadingText">AI 正在生成回复...</div>
                        <div class="xkLoadingSub">请耐心等待，不要关闭窗口</div>
                    </div>
                </div>
            </div>
            <template v-else-if="tabIndex!=2 && tabIndex!=3 && tabIndex!=4">
            <div v-if="isSeaching" class="searchingBar">
                <img v-if="showAiSwitch" class="searchingBarIcon" src="https://imagessl.lingtuo.cn/A-1ed71af7_20241023111358.png" />
                <el-switch v-if="showAiSwitch" v-model="isAISearch" active-color="#FB5D5C" ></el-switch>
                <div v-if="(isAISearch&&huashuTeamList[teamSelIdx].roleId==2)||(huashuTeamList&&huashuTeamList[teamSelIdx].isOpenAiRec)" :style="{'margin-left':'32px'}">
                    <el-radio-group v-model="aiSearchType">
                        <el-radio :label="1">关键词搜索</el-radio>
                        <el-radio :label="2">AI搜索</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <multipane class="custom-resizer" layout="vertical" @paneResizeStop="paneresizestop">
                <div v-if="!isSeaching" class="typeList" ref="typeList"
                    :style="{'width':typeListWidth+'px'}" @scroll="typeOnScroll">
                    <div v-if="tabIndex==0" @scroll="typeOnScroll">
                        <div v-for="(item,idx) in typeList"
                            :class="typeSelIdx==idx?'typeListItemSel typeListItem':'typeListItem'"
                            :key="'huashuType'+idx" @click="huashuClick(idx)"
                            @contextmenu.prevent="showTypeMenu($event,item,idx)">
                            <div>{{item.labelName}}</div>
                        </div>
                    </div>
                    <div v-else-if="tabIndex==1" @scroll="typeOnScroll">
                        <div v-for="(item,idx) in themeCategoryList"
                            :class="themeCategorySelIdx==idx?'typeListItemSel typeListItem':'typeListItem'"
                            :key="'wenanType'+idx" @click="wenanCategoryClick(idx)">
                            <div>{{item.labelName}}</div>
                        </div>
                    </div>
                </div>
                <multipane-resizer v-if="!isSeaching">
                    <div class="sizeBtn">
                        <div></div>
                        <div></div>
                    </div>
                </multipane-resizer>
                <div class="huashuList" ref="huashuList"
                    :style="{'padding-top':(countTopHuashu>0&&tabIndex==0)||isSeaching?'32px':0,'margin-top':'-1px'}"
                    @scroll="huashuOnScroll">
                    <div v-if="tabIndex==0" :style="{'padding-bottom':countTopHuashu>0?'32px':0}" @mouseleave="huashuListMouseleave">
                        <div v-if="countTopHuashu&&!isSeaching" class="topBar" @click="openTopHuashu">
                            <div class="topBarL">
                                <img src="https://imagessl.lingtuo.cn/A-1ed71af7_20240705101043.png" />{{countTopHuashu}}条置顶内容
                            </div>
                            <img v-if="!huashuTopBarShow" class="topBarR"
                                src="https://imagessl.lingtuo.cn/A-1ed71af7_20240705101203.png" />
                            <img v-else class="topBarR"
                                src="https://imagessl.lingtuo.cn/A-1ed71af7_20240708100936.png" />
                        </div>
                        <div v-for="(item,idx) in showHuashuList" class="huashuListItem" @mouseenter="huashuItemMouseIn($event,item,idx)" @mouseover="huashuItemHover($event,item,idx)" @mouseleave="huashuItemMouseleave" :key="'showHuashuList'+item.id+idx"
                        :style="{'background-color':getHuashuItemBgColor(item,idx),'border-bottom':isSeaching?'1px solid #eee':0}"
                        @contextmenu.prevent="showMenu($event,item,idx)">
                        <!-- <div v-for="(item,idx) in showHuashuList" class="huashuListItem" @mouseover="huashuItemHover($event,item)" :key="'showHuashuList'+item.id+idx"
                        :style="{'background-color':item.isTop?'#eee':'#fff'}"
                        @contextmenu.prevent="showMenu($event,item,idx)"> -->
                            <div v-if="item.title" class="huashuListItemTop">
                                <img v-if="false" class="huashuListItemTopL"
                                    src="https://imagessl.edujia.com/A-1ed71af7_20230804141027.png">
                                <img v-if="item.imglist&&item.imglist.length" class="huashuListItemTopR"
                                    src="https://imagessl.edujia.com/A-1ed71af7_20231025161026.png"
                                    @click="go2ImageList(item)">
                                <img v-else-if="item.filelist&&item.filelist.length" class="huashuListItemTopR"
                                    src="https://imagessl.edujia.com/A-1ed71af7_20231025160840.png"
                                    @click="go2ImageList(item)">
                                <div class="huashuListItemTopM" :style="{'color':titleColor}">{{item.title}}</div>
                            </div>
                            <div :ref="item.id" class="huashuListItemDetailNoHide" v-html="item.allText"></div>
                            <div v-if="item.title">
                                <div :class="(item.showBtn&&item.showBtn=='shouqi')?'huashuListItemDetailShowmore':'huashuListItemDetail'"
                                    :style="{'-webkit-line-clamp':wenanShowLineCount==-1?'unset':wenanShowLineCount}"
                                    :ref="'show'+item.id" @click="itemClick(idx)" @dblclick="itemClick(idx,true)" v-html="item.allText"></div>
                                <!-- <div v-if="item.showBtn=='zhankai'&&!hoverPreviewCheck" class="actionBtn" @click.stop="textShowClick(idx)"> -->
                                <!-- <div v-else-if="item.showBtn=='shouqi'&&!hoverPreviewCheck" class="actionBtn"
                                    @click.stop="textShowClick(idx)">收起</div> -->
                                <div v-if="item.showBtn=='zhankai'&&!hoverPreviewCheck" class="actionBtn" @click.stop="textShowClick(idx)">
                                    展开</div>
                                <div v-else-if="item.showBtn=='shouqi'&&!hoverPreviewCheck" class="actionBtn"
                                    @click.stop="textShowClick(idx)">收起</div>
                            </div>
                            <div v-else>
                                <div class="huashuListItemDetail huashuListItemDetailNoTitle" :ref="'show'+item.id"
                                    :style="{'text-indent':(item.imglist&&item.imglist.length)||(item.filelist&&item.filelist.length)?'26px':0,'display':(item.showBtn&&item.showBtn=='shouqi')?'block':'-webkit-box','-webkit-line-clamp':wenanShowLineCount==-1?'unset':wenanShowLineCount}"
                                    @click="itemClick(idx)" @dblclick="itemClick(idx,true)">
                                    <img v-if="item.imglist&&item.imglist.length" class="imgTmp"
                                        src="https://imagessl.edujia.com/A-1ed71af7_20231025161026.png"
                                        @click.stop="go2ImageList(item)">
                                    <img v-else-if="item.filelist&&item.filelist.length" class="imgTmp"
                                        src="https://imagessl.edujia.com/A-1ed71af7_20231025160840.png"
                                        @click.stop="go2ImageList(item)">
                                    <div v-html="item.allText"></div></div>
                                <!-- <div v-if="item.showBtn=='zhankai'&&!hoverPreviewCheck" class="actionBtn" @click.stop="textShowClick(idx)">
                                    展开</div>
                                <div v-else-if="item.showBtn=='shouqi'&&!hoverPreviewCheck" class="actionBtn"
                                    @click.stop="textShowClick(idx)">收起</div> -->
                                    <div v-if="item.showBtn=='zhankai'&&!hoverPreviewCheck" class="actionBtn" @click.stop="textShowClick(idx)">
                                    展开</div>
                                <div v-else-if="item.showBtn=='shouqi'&&!hoverPreviewCheck" class="actionBtn"
                                    @click.stop="textShowClick(idx)">收起</div>
                            </div>
                        </div>
                    </div>
                    <div v-if="tabIndex==1">
                        <div class="huashuListItem" :style="{'border':'none'}">
                            <div v-if="themeList.length&&themeList[themeSelIdx].title" class="huashuListItemTop">
                                <!-- <img class="huashuListItemTopL" src="https://imagessl.edujia.com/A-1ed71af7_20230804141027.png"> -->
                                <!-- <div class="huashuListItemTopM huashuListItemTopMBig">{{themeList[themeSelIdx].title}}</div> -->
                                <!--  <img v-if="item.imglist&&item.imglist.length" class="huashuListItemTopR" src="https://imagessl.edujia.com/A-1ed71af7_20231025161026.png" @click="go2ImageList(idx)">
                                    <img v-else-if="item.filelist&&item.filelist.length" class="huashuListItemTopR" src="https://imagessl.edujia.com/A-1ed71af7_20231025160840.png" @click="go2ImageList(idx)"> -->
                            </div>
                            <!-- <div v-for="(wenan,idx) in wenanList" @contextmenu.prevent="showWenanMenu($event,wenan,idx)"> -->
                            <div v-for="(wenan,idx) in wenanList" :key="'wenanListItem'+idx" class="huashuListItemDetailP">
                                <div :ref="wenan.libraryId" class="huashuListItemDetailNoHide">{{wenan.text}}</div>
                                <!-- <div v-if="item.title"> -->
                                <div :class="(wenan.showBtn&&wenan.showBtn=='shouqi')?'huashuListItemDetailShowmore':'huashuListItemDetail'"
                                    :style="{'-webkit-line-clamp':wenanShowLineCount==-1?'unset':wenanShowLineCount}"
                                    :ref="'show'+wenan.libraryId" @click="wenanItemClick(idx)" @dblclick="wenanItemClick(idx,true)">{{wenan.text}}</div>
                                <div v-if="wenan.showBtn=='zhankai'&&!hoverPreviewCheck" class="actionBtn" @click.stop="textShowClick(idx)">
                                    展开</div>
                                <div v-else-if="wenan.showBtn=='shouqi'&&!hoverPreviewCheck" class="actionBtn"
                                    @click.stop="textShowClick(idx)">收起</div>
                                <!-- </div>
                                    <div v-else>
                                        <div class="huashuListItemDetail huashuListItemDetailNoTitle" :ref="'show'+item.id" :style="{'text-indent':(item.imglist&&item.imglist.length)||(item.filelist&&item.filelist.length)?'23px':0,'display':(item.showBtn&&item.showBtn=='shouqi')?'block':'-webkit-box'}" @click="itemClick(idx)">
                                            <img v-if="item.imglist&&item.imglist.length" class="imgTmp" src="https://imagessl.edujia.com/A-1ed71af7_20231025161026.png" @click.stop="go2ImageList(idx)">
                                            <img v-else-if="item.filelist&&item.filelist.length" class="imgTmp" src="https://imagessl.edujia.com/A-1ed71af7_20231025160840.png" @click.stop="go2ImageList(idx)">
                                            {{item.allText}}
                                        </div>
                                        <div v-if="item.showBtn=='zhankai'" class="actionBtn" @click.stop="textShowClick(idx)">展开</div>
                                        <div v-else-if="item.showBtn=='shouqi'" class="actionBtn" @click.stop="textShowClick(idx)">收起</div>
                                    </div> -->
                            </div>
                        </div>
                        
                    </div>
                    <!-- <huashu-item-right-menu v-show="menuShow" ref="chat-item-right-menu" :menuY="menuPos[1]" :menuX="menuPos[0]" :menuData="menuData" @edit="editHuashu" @remove="removeHuashu" @hideMenu="hideMenu"></huashu-item-right-menu> -->
                </div>
            </multipane>
            </template>
            <memo-list v-if="!xiaoguanShow && tabIndex===2" ref="memoList" :height="contentHeight"></memo-list>
            <clipboard-history v-if="!xiaoguanShow && tabIndex===3" ref="clipboardHistory" :height="contentHeight"
                @add-to-huashu="onClipboardAddToHuashu"></clipboard-history>
            <skill-list v-if="!xiaoguanShow && tabIndex===4" ref="skillList" :height="contentHeight"></skill-list>
        </div>
        <right-menu v-show="menuShow" ref="chat-item-right-menu" :menuY="menuPos[1]" :menuX="menuPos[0]"
            :cellList="menuCellList" @cellClick="rightMenuCellClick" @hideMenu="hideMenu"></right-menu>
        <div  v-if="tabIndex==0 && !xiaoguanShow" class="bottomBarP" ref="bottomBarP">
            <div class="bottomBar">
                <div class="bottomBarL">
                    <div class="addTypeBtn" @click="addHuashuType">
                        <img src="https://imagessl.edujia.com/A-1ed71af7_20230825105123.png" />
                        <div>添加分类</div>
                    </div>
                    <div class="addHuashuBtn" @click="addHuashu">
                        <img src="https://imagessl.edujia.com/A-1ed71af7_20230825105123.png" />
                        <div>添加话术</div>
                    </div>
                    <div class="importHuashuBtn" @click="importHuashu">
                        <img src="https://imagessl.lingtuo.cn/A-1ed71af7_20241028160310.png">
                        <div>导入话术</div>
                    </div>
                </div>
                <!-- <div class="psLbl">鼠标右键编辑/删除</div> -->
                <div class="faceBtn" @click="faceBtnClick"><div>&#128515</div><div class="faceBtnlbl">表情</div></div>
            </div>
        </div>
        <el-dialog title="选择分类" :visible.sync="showChooseHuashuTypeDialog">
            <div class="chooseHuashuTypeList">
                <div v-for="(item,idx) in typeList"
                    :class="chooseTypeSelIdx==idx?'typeListItemSel typeListItem':'typeListItem'"
                    :key="'huashuChooseType'+idx" @click="chooseHuashuTypeClick(idx)">
                    <div>{{item.labelName}}</div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="chooseHuashuTypeCancel">取 消</el-button>
                <el-button type="primary" @click="chooseHuashuTypeConfirm">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="sortDialogVisible" :show-close="true" width="480px"
          custom-class="sortTypeDialog" @close="closeSortDialog">
          <div slot="title" class="sortDialogHeader">
            <span class="sortDialogTitle">按住分类拖动排序</span>
            <div class="sortDialogSaveBtn" @click="saveSortOrder">保存</div>
          </div>
          <transition-group name="sort-flip" tag="div" class="sortTypeList">
            <div v-for="(item, idx) in sortTypeList" :key="item.labelId"
              class="sortTypeItem"
              :class="{
                'sortTypeItemDragging': dragIndex === idx,
                'sortTypeItemDragOver': dragOverIndex === idx && dragIndex !== idx
              }"
              draggable="true"
              @dragstart="onSortDragStart(idx)"
              @dragover.prevent="onSortDragOver(idx)"
              @drop="onSortDrop(idx)"
              @dragend="onSortDragEnd">
              <div>{{ item.labelName }}</div>
            </div>
          </transition-group>
        </el-dialog>
        <el-dialog title="行业/产品" :visible.sync="showProductDialog" width="420px" :append-to-body="true" @close="onProductDialogClose">
            <div class="xkProductList">
                <div v-if="!productList.length" class="xkProductEmpty">请到APP-销冠键盘，添加产品</div>
                <div v-for="(item,idx) in productList" :key="'product'+idx"
                    :class="xkSelProductIdx==idx?'xkProductItem xkProductItemSel':'xkProductItem'"
                    @click="productItemClick(idx)">
                    <div>{{item.name}}</div>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="选择团队" :visible.sync="showHuashuSelectDialog" width="520px" :append-to-body="true" @close="onHuashuSelectDialogClose">
            <div class="xkTeamList">
                <div v-if="!huashuTeamList.length" class="xkProductEmpty">暂无数据</div>
                <div v-for="(item,idx) in huashuTeamList" :key="'xkTeam'+idx"
                    :class="xkSelTeamIdx==idx?'teamListItemSel teamListItem':'teamListItem'"
                    @click="xkTeamItemClick(idx)">
                    <img v-if="item.roleId==1" src="https://imagessl.edujia.com/A-1ed71af7_20231025160408.png" />
                    <img v-else-if="item.roleId==2" src="https://imagessl.edujia.com/A-1ed71af7_20231025160621.png" />
                    <div>{{item.showName}}</div>
                </div>
            </div>
        </el-dialog>
        <!-- 剪贴板“添加到话术”：必须先选团队、再选团队下的话术分类，选完才打开添加话术窗口 -->
        <el-dialog title="选择团队" :visible.sync="clipboardTeamDialogShow" width="460px" :append-to-body="true"
            :close-on-click-modal="false" @close="onClipboardTeamDialogClose">
            <div class="clipboardTeamTip">请选择要添加到话术的团队</div>
            <div class="clipboardTeamList" v-loading="clipboardTeamLoading">
                <div v-if="!clipboardTeamLoading&&!huashuTeamList.length" class="clipboardTeamEmpty">暂无可选团队</div>
                <div v-for="(item,idx) in huashuTeamList" :key="'clipboardTeam'+idx"
                    :class="idx==teamSelIdx?'teamListItemSel teamListItem':'teamListItem'"
                    @click="clipboardTeamItemClick(idx)">
                    <img v-if="item.roleId==1" src="https://imagessl.edujia.com/A-1ed71af7_20231025160408.png" />
                    <img v-else-if="item.roleId==2"
                        src="https://imagessl.edujia.com/A-1ed71af7_20231025160621.png" />
                    <div>{{item.showName}}</div>
                </div>
            </div>
            <div slot="footer">
                <el-button size="small" @click="clipboardTeamDialogShow=false">取 消</el-button>
            </div>
        </el-dialog>
        <!-- 剪贴板“添加到话术”第二步：选团队下的话术分类（必选） -->
        <el-dialog title="选择话术分类" :visible.sync="clipboardTypeDialogShow" width="460px" :append-to-body="true"
            :close-on-click-modal="false" @close="onClipboardTypeDialogClose">
            <div class="clipboardTeamTip">
                请选择「{{clipboardTargetTeamName}}」下要添加到的分类
            </div>
            <div class="clipboardTeamList" v-loading="clipboardTypeLoading">
                <div v-if="!clipboardTypeLoading&&!clipboardTeamTypeList.length" class="clipboardTeamEmpty">
                    该团队下暂无可选分类，请先在话术里创建分类
                </div>
                <div v-for="(item,idx) in clipboardTeamTypeList" :key="'clipboardType'+idx"
                    :class="idx==clipboardTeamTypeSelIdx?'teamListItemSel teamListItem':'teamListItem'"
                    @click="clipboardTypeItemClick(idx)">
                    <div>{{item.labelName}}</div>
                </div>
            </div>
            <div slot="footer">
                <el-button size="small" @click="clipboardTypeDialogShow=false">取 消</el-button>
                <el-button size="small" type="primary" :disabled="!clipboardTeamTypeList.length"
                    @click="clipboardTypeConfirm">确 定</el-button>
            </div>
        </el-dialog>
        <face-panel v-if="facePanelShow" @facePanelClose="facePanelShow=false" @emojiClick="emojiClick"></face-panel>
        <!-- <el-dialog title="文案显示" custom-class="wenanLineCountDialog" :visible.sync="huashuLineCountDialogShow"
            @close='()=>{this.$store.commit("modifyHuashuLineCountDialogShow",false)}'>
            <div class="chooseHuashuTypeList">
                <el-radio-group v-model="tmpWenanShowLineCount" :style="{'display':'grid'}">
                    <el-radio :label="1" :style="{'margin-bottom':'10px'}">最多显示1行内容</el-radio>
                    <el-radio :label="3" :style="{'margin-bottom':'10px'}">最多显示3行内容</el-radio>
                    <el-radio :label="-1" :style="{'margin-bottom':'10px'}">全部显示</el-radio>
                </el-radio-group>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="wenanLineCountCancel">取 消</el-button>
                <el-button type="primary" @click="wenanLineCountConfirm">确 定</el-button>
            </div>
        </el-dialog> -->
    </div>


</template>

<script>
    import axios from 'axios'
    import dbService from '@/service/dbService'
    import Vue from 'vue'
    import Fuse from 'fuse.js'
    import {
        Dialog,
        Button,
        Loading,
        Radio,
        RadioGroup,
        Switch,
        Checkbox,
        Message
    } from 'element-ui';
    Vue.use(Dialog)
    Vue.use(Button)
    Vue.use(Loading)
    Vue.use(RadioGroup)
    Vue.use(Radio)
    Vue.use(Switch)
    Vue.use(Checkbox)

    import LoginDialog from "./LoginDialog";
    import rightMenu from '@/components/RightMenu'
    import facePanel from '@/components/FacePanel'
    import memoList from '@/components/MemoList'
    import clipboardHistory from '@/components/ClipboardHistory'
    import skillList from '@/components/SkillList'
    import {
        isReminderDue,
        formatRemind,
        reminderFireKey,
        nextOccurrence,
        setMemoListCache,
        getMemoListCache
    } from '@/service/memoRemindService'
    import {
        Multipane,
        MultipaneResizer
    } from 'vue-multipane';
    import { recognizeImageText, stripBase64, OCR_IMAGE_MAX_SIZE } from '@/service/ocrService';
    import {
        normalizeHomeTopTabs,
        homeTabsFromSettingInfo,
        loadLocalHomeTopTabs,
        saveLocalHomeTopTabs,
    } from '@/common/js/homeTopTabs';
    // var mammoth = require("mammoth");

    export default {
        name: "Home",
        data() {
            return {
                pageWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
                pageHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
                typeSelIdx: 0,
                teamSelIdx: 0,
                typeList: [],
                typeListLoadend: false,
                huashuList: [],
                showHuashuList: [],
                huashuListLoadend: false,
                huashuTeamList: [],
                typePageSize: 500,
                typePage: 1,
                huashuPageSize: 500,
                huashuPage: 1,
                speechId: 0, //团队id
                labelId: 0, //分类id
                huashuDetailId: 0, //话术文本id
                huashuTopBarShow: true,
                defaultThemeList: [], //默认文案包列表
                themeList: [], //文案包列表
                themeSelIdx: 0, //当前选中文案包索引
                themeId: 0, //当前选中文案包id
                themePage: 1,
                themePageSize: 500,
                themeCategoryList: [], //当前选中文案包分类列表
                themeCategorySelIdx: 0, //当前选中文案包分类索引
                themeCategoryPage: 1,
                themeCategoryPageSize: 20,
                themeCategoryLoading: false,
                themeCategoryLoadend: false,
                wenanLabelId: 0, //文案包分类id
                wenanPage: 1,
                wenanPageSize: 500,
                wenanloading: false,
                wenanList: [],
                wenanListLoadend: false,
                wenanId: 0, //文案id
                teamListShow: false,
                clipboardTeamDialogShow: false, //剪贴板“添加到话术”的团队选择弹框
                clipboardTeamLoading: false, //剪贴板“添加到话术”的团队列表加载中
                clipboardHuashuText: "", //待添加到话术的剪贴板文案
                clipboardHuashuMedia: null, //待添加到话术的剪贴板图片/文件（{type,imagePath} 或 {type,files}）
                clipboardAddStep: "", //剪贴板“添加到话术”当前步骤：team=选团队，type=选分类，空=未开始
                clipboardTypeDialogShow: false, //剪贴板“添加到话术”的分类选择弹框
                clipboardTypeLoading: false, //分类列表加载中
                clipboardTeamTypeList: [], //所选团队下的分类列表
                clipboardTeamTypeSelIdx: 0, //所选分类索引
                clipboardTargetTeamIdx: -1, //所选团队索引
                xiaoguanShow: false,
                xiaoguanQuestion: "",
                xkOcrLoading: false,
                xkPromptingImage: false,
                xkCategorySelIdx: -1,
                xkCategoryLoading: false,
                xkSegmentTab: 0,
                showProductDialog: false,
                xkSelProductIdx: -1,
                xkSelProduct: "",
                productList: [],
                showProductAddInput: false,
                newProductName: "",
                showHuashuSelectDialog: false,
                xkSelTeamIdx: -1,
                xiaoguanCategoryList: [
                    { label: "智能回复", key: "高情商" },
                    { label: "议价问题", key: "议价" },
                    { label: "建立信任", key: "信任" },
                    { label: "挖掘需求", key: "需求" },
                    { label: "产品异议", key: "异议" },
                    { label: "塑造价值", key: "价值" },
                    { label: "签单推进", key: "签单" },
                    { label: "遭遇拒绝", key: "拒绝" },
                    { label: "逼单成交", key: "逼单" },
                    { label: "销冠回复", key: "销冠" },
                    { label: "产品介绍", key: "产品介绍" },
                    { label: "售后维护", key: "售后维护" },
                    { label: "转介绍", key: "转介绍" },
                    { label: "闲聊", key: "闲聊" },
                    { label: "客情维系", key: "客情维系" },
                    { label: "邀约", key: "邀约" },
                    { label: "复购", key: "复购" },
                    { label: "签单祝贺", key: "签单祝贺" },
                    { label: "客户挽留", key: "客户挽留" },
                ],
                xkCategoryList2: [
                    { label: "自我介绍", key: "自我介绍" },
                    { label: "需求探寻", key: "需求探寻" },
                    { label: "消除顾虑", key: "消除顾虑" },
                    { label: "互动提问", key: "互动提问" },
                    { label: "传达价值", key: "传达价值" },
                    { label: "挖掘兴趣", key: "挖掘兴趣" },
                    { label: "情感链接", key: "情感链接" },
                    { label: "分享趋势", key: "分享趋势" },
                    { label: "引导深入", key: "引导深入" },
                    { label: "闲聊", key: "闲聊" },
                    { label: "客情维系", key: "客情维系" },
                    { label: "邀约", key: "邀约" },
                    { label: "复购", key: "复购" },
                    { label: "签单祝贺", key: "签单祝贺" },
                    { label: "客户挽留", key: "客户挽留" },
                ],
                loading: false,
                hushuTypeLoading: false,
                audioList: [],
                eleList: [],
                faceIcon: "",
                // loginDailogShow:false,
                menuPos: [],
                menuShow: false,
                menuData: {},
                tabIndex: 0,
                keywords: "",
                searchPage: 1,
                searchPageSize: 50,
                searchLoadend: false,
                searchLoading: false,
                isSeaching: false,
                typeListWidth: 144,
                menuCellList: [],
                memoRemindFireTimer: null, //备忘提醒精确定时器
                memoReminderBanner: null, //备忘提醒App内横幅数据
                countTopHuashu: 0,
                showChooseHuashuTypeDialog: false,
                chooseTypeSelIdx: 0,
                huashuItemHoverTimer:null,
                huashuItemHoverIdx:-1,
                isAISearch:false,
                aiSearchHeight:48,
                aiSearchType:1,//ai搜索类型：1.关键词搜搜 2.AI搜索
                facePanelShow:false,
                isHuashuItemHovering:false,//判断是否是悬停查看话术详情状态
                itemClickTimer:null,
                searchType:"",//类型：1增量同步，2七牛云同步，3服务端搜索，4更新同步参数无增量数据
                localHuashuListData:[],
                huashuValList:[],
                currentHuashuTeamInfo:null,
                sortDialogVisible: false,
                sortTypeList: [],
                dragIndex: -1,
                dragOverIndex: -1,
                // 首页顶部 Tab：保留哪些 + 顺序，配置来自设置页（settingInfo.homeTopTabs），
                // 老版本长按排序写下的 local 配置作为兜底，见 common/js/homeTopTabs.js
                topTabOrder: [],
                topTabLongPressTimer: null,
                topTabPress: null,
                topTabDrag: { active: false, key: null },
                topTabSuppressClick: false,
                homeMounted: false,
            }
        },
        computed: {
            clipboardTargetTeamName() {
                const team = this.huashuTeamList[this.clipboardTargetTeamIdx];
                return team ? team.showName : "";
            },
            xkCurrentCategoryList() {
                return this.xkSegmentTab === 0 ? this.xiaoguanCategoryList : this.xkCategoryList2;
            },
            showAiSwitch(){
                // return this.isSeaching&&(this.huashuTeamList[this.teamSelIdx].roleId==2||this.huashuTeamList[this.teamSelIdx].isOpenAiRec)
                return this.isSeaching&&this.huashuTeamList[this.teamSelIdx].roleId==2
            },
            contentHeight() {
                let height = this.pageHeight - 125 - 40;
                if(this.isSeaching&&this.showAiSwitch){
                    height-=this.aiSearchHeight
                }
                if (this.tabIndex == 1 || this.tabIndex == 2 || this.tabIndex == 3 || this.tabIndex == 4) {
                    height += 32 + 40;
                }
                return height;
            },
            loginDailogShow() {
                return this.$store.state.loginDailogShow;
            },
            wenanShowLineCount(){
                console.log("this.$store.state.settingInfo.wenanShowLineCount:",this.$store.state.settingInfo.wenanShowLineCount);
                return this.$store.state.settingInfo.wenanShowLineCount?this.$store.state.settingInfo.wenanShowLineCount:3
            },
            titleColor(){
                console.log("this.$store.state.settingInfo.color:",this.$store.state.settingInfo.color);
                return this.$store.state.settingInfo.color?this.$store.state.settingInfo.color:'#4A90E2';
            },
            hoverPreviewCheck(){
                return this.$store.state.settingInfo&&this.$store.state.settingInfo.hoverPreviewCheck
            },
            // 设置页改「首页页签」后，主进程会把新的 settingInfo 广播到主窗口，
            // 这里跟着变 → watcher 立刻重排顶栏（不用重启客户端）
            storeHomeTopTabs() {
                const info = this.$store.state.settingInfo;
                return info ? info.homeTopTabs : undefined;
            },
        },
        watch: {
            typeListWidth(val){
                console.log("typeListWidth change:",val)
            },
            isAISearch(){
                if(this.isSeaching){
                    this.searchPage = 1;
                    this.huashuList = [];
                    this.searchLoadend = false;
                    this.searchHuashu();
                }
            },
            aiSearchType(){
                if(this.isSeaching){
                    this.searchPage = 1;
                    this.huashuList = [];
                    this.searchLoadend = false;
                    this.searchHuashu();
                }
            },
            wenanShowLineCount(val) {
                this.updateCellStyle();
            },
            keywords(val) {
                if (!val) {
                    this.isSeaching = false;
                }
            },
            huashuList(val) {
                console.log("watch huashuList update:", val);
                if (this.huashuTopBarShow) {
                    this.showHuashuList = this.huashuList;
                } else {
                    this.showHuashuList = this.huashuList.filter((huashu) => {
                        return !huashu.isTop
                    });
                }
                this.countTopHuashu = this.huashuList.filter((val) => {
                    return val.isTop
                }).length;
            },
            tabIndex() {
                this.saveActiveTabState();
                this.attachBottomBarWheel();
            },
            xiaoguanShow() {
                this.saveActiveTabState();
            },
            storeHomeTopTabs(val) {
                // 设置项里还没有这一项（老用户升级上来 / 刚恢复过默认设置）→ 用本地缓存，再不行用默认
                if (!Array.isArray(val)) {
                    this.applyHomeTopTabs(loadLocalHomeTopTabs());
                    return;
                }
                this.applyHomeTopTabs(val);
            },
        },
        components: {
            LoginDialog,
            rightMenu,
            Multipane,
            MultipaneResizer,
            facePanel,
            memoList,
            clipboardHistory,
            skillList
        },
        methods: {
            // 统一兜底：原来的写法是 new Promise(async (resolve,reject)=>{ ... await this.$http.xxx() ... })
            // 执行器是 async 时，内部 await 一旦失败（网络错误/超时），异常会被执行器自己吞掉，
            // 外层 Promise 永远不会 settle —— 启动时第一次请求失败就会让 fetchData() 永久卡在
            // 第一个 await 上：所有列表永远为空、且不报错、不重试。现场表现就是
            // "刚打开软件所有接口的数据都没出现，关掉重开又好了"。
            // 这里包一层：无论内部抛异常、还是提前 return（没调到 resolve），都保证 Promise 一定 settle。
            ensureSettled(executor) {
                return new Promise((resolve) => {
                    let settled = false;
                    const safeResolve = (value) => {
                        if (settled) return;
                        settled = true;
                        resolve(value);
                    };
                    try {
                        const ret = executor(safeResolve, safeResolve);
                        if (ret && typeof ret.then === "function") {
                            ret.then(
                                () => safeResolve(),
                                (err) => {
                                    this._lastRequestFailed = true;
                                    console.error("[ensureSettled] 请求失败（已放行，避免永久挂起）:", err);
                                    safeResolve();
                                }
                            );
                        }
                    } catch (err) {
                        this._lastRequestFailed = true;
                        console.error("[ensureSettled] 执行异常（已放行，避免永久挂起）:", err);
                        safeResolve();
                    }
                });
            },
            replaceHuashuBianliang(text, withColor = false){
                if (typeof text !== 'string') {
                    return text;
                }
                this.huashuValList.forEach((val)=>{
                    //变量没填值时，显示字段名占位，避免直接把内容替换没了
                    let tmp = val.value;
                    if (tmp === undefined || tmp === null || tmp === "") {
                        tmp = val.fieldText ? "{" + val.fieldText + "}" : "[变量]";
                    }
                    //列表展示时给变量文字加蓝色高亮，和编辑页里的变量样式保持一致
                    if (withColor) {
                        tmp = '<span style="color:#4A90E2">' + tmp + '</span>';
                    }
                    text=this.replaceAll(text, "{$*"+val.id+"*$}" , tmp);
                })
                const regex = /\{\$\*\d+\*\$\}/g;
                text = text.replace(regex, withColor ? '<span style="color:#4A90E2">[变量]</span>' : "[变量]");
                return text;
            },
            //生成话术列表展示用的eleList/imglist/filelist/allText
            //注意：不要覆盖 speechText，否则编辑/保存时会丢失变量占位符
            decorateHuashuItem(val){
                if (!val) {
                    return val;
                }
                const rawText = val.speechText || "";
                //发送/复制用：变量替换成具体文字，不带颜色标签，避免把span当文字发出去
                const plainText = this.convertColorTags(this.replaceHuashuBianliang(rawText));
                val.eleList = this.generateEleList(plainText);
                val.imglist = val.eleList.filter((eleListItem) => {
                    eleListItem.val = eleListItem.val.replace("http://", "https://")
                    return eleListItem.type == 'img' || eleListItem.type == 'video'
                })
                val.filelist = val.eleList.filter((eleListItem) => {
                    eleListItem.val = eleListItem.val.replace("http://", "https://")
                    return eleListItem.type == 'file' || eleListItem.type == 'audio'
                })
                //列表展示用：变量文字蓝色高亮
                const colorText = this.convertColorTags(this.replaceHuashuBianliang(rawText, true));
                val.allText = this.getEleListAllText(this.generateEleList(colorText));
                return val;
            },
            //变量列表变化后，重新渲染已经加载的话术
            refreshHuashuItemText(){
                if (!this.huashuList || !this.huashuList.length) {
                    return;
                }
                this.huashuList.forEach((val) => {
                    this.decorateHuashuItem(val);
                });
            },
            getSyncParams(speechId){
                let syncParams=null;
                let resultIdx = -1;
                let syncParamsList = [];
                if(localStorage.getItem("syncParamsList")){
                    syncParamsList = JSON.parse(localStorage.getItem("syncParamsList"));
                    resultIdx = syncParamsList.findIndex((val)=>{return val.speechId == speechId})
                    if(resultIdx>=0){
                        syncParams = syncParamsList[resultIdx].syncParams;
                    }
                }
                return syncParams;
            },
            updateSyncParams(syncParams,speechId){
                return new Promise((resolve,reject)=>{
                    let resultIdx = -1;
                    let syncParamsList = [];
                    if(localStorage.getItem("syncParamsList")){
                        syncParamsList = JSON.parse(localStorage.getItem("syncParamsList"));
                        resultIdx = syncParamsList.findIndex((val)=>{return val.speechId == speechId})
                        if(resultIdx>=0){
                            syncParams = syncParamsList[resultIdx].syncParams;
                        }
                    }
                    if(resultIdx>=0){
                        syncParamsList[resultIdx].syncParams =syncParams 
                    }else{
                        syncParamsList.push({
                            syncParams:syncParams,
                            speechId:speechId
                        })
                    }
                    localStorage.setItem("syncParamsList",JSON.stringify(syncParamsList));
                    resolve();
                })
            },
            async huashuCheckIncrement(){
                return new Promise(async (resolve,reject)=>{
                    let syncParams=this.getSyncParams(this.speechId);
                    let params = {
                        speechId: this.speechId,
                    }
                    if(syncParams){
                        params.syncParams = syncParams;
                    }
                    console.log("huashuCheckIncrement params=", params);
                    let resp = await this.$http.huashuCheckIncrement(params)
                    if (resp.code == 200) {
                        if(resp.data.object.syncParams){
                           await this.updateSyncParams(resp.data.object.syncParams,this.speechId)
                        }
                        this.searchType = resp.data.object.type;
                        //有增量更新
                        if(this.searchType!=4){
                            if(this.searchType==2){
                                //七牛云同步
                                axios.get(resp.data.object.url).then(async response => {
                                    console.log("response:",response);
                                    if(response.data&&response.data.length){
                                        this.localHuashuListData.push(...response.data);
                                        await dbService.addData('huashuList',response.data,new Date().getTime(),this.speechId)
                                    }
                                    await this.huashuCheckIncrement(resp.data.object.syncParams);
                                    resolve();
                                })
                            }else if(this.searchType==1){
                                //增量添加
                                await this.huashuCheckIncrementAdd(resp.data.object.syncParams);

                                //增量删除
                                await this.huashuCheckIncrementDel(resp.data.object.syncParams);
                                resolve();
                            }
                        }else{
                            resolve();
                        }
                    }
                })
            },
            //增量添加
            huashuCheckIncrementAdd(syncParams){
                return new Promise(async (resolve,reject)=>{
                    let zenParam={
                        speechId:this.speechId,
                    }
                    if(syncParams){
                        zenParam.syncParams = syncParams;
                    }
                    let zenResp = await this.$http.huashuCheckIncrementAdd(zenParam)
                    if(zenResp.code == 200){
                        if(zenResp.data.syncParams){
                            await this.updateSyncParams(zenResp.data.syncParams,this.speechId)
                        }
                        if(zenResp.data.array.length){
                            await dbService.addData('huashuList',zenResp.data.array,this.speechId)
                            this.localHuashuListData.push(...zenResp.data.array);
                            if(zenResp.data.isNextData){
                                await this.huashuCheckIncrementAdd(zenResp.data.syncParams)
                            }
                        }else{
                            console.log("增量增加拉取结束...");
                        }
                    }
                    resolve();
                })
            },
            //增量删除
            huashuCheckIncrementDel(syncParams){
                return new Promise(async (resolve,reject)=>{
                    let delParam={
                        speechId:this.speechId,
                    }
                    if(syncParams){
                        delParam.syncParams = syncParams;
                    }
                    let delResp = await this.$http.huashuCheckIncrementDel(delParam)
                    if(delResp.code == 200){
                        if(delResp.data.syncParams){
                           await this.updateSyncParams(delResp.data.syncParams,this.speechId)
                        }
                        if(delResp.data.array.length){
                            // this.localHuashuListData.push(...response.data);
                            this.localHuashuListData=this.localHuashuListData.filter((item)=>{
                                return !delResp.data.array.some((removeitem)=>{
                                    return removeitem.id == item.id;
                                })
                            })
                            await dbService.delData('huashuList',delResp.data.array)
                            if(delResp.data.isNextData){
                                await this.huashuCheckIncrementDel(delResp.data.syncParams)
                            }
                        }else{
                            console.log("增量删除拉取结束...");
                        }
                    }
                    resolve();
                })
            },
            getHuashuItemBgColor(item,idx){
                let color = '#fff'
                if(item.isTop&&!this.isSeaching){
                    color = '#eee'
                }

                if(this.huashuItemHoverIdx==idx){
                    if(color=='#fff'){
                        color = '#eee'
                    }else{
                        color = '#fff'
                    }
                }

                return color;
            },
            emojiClick(emoji){
                navigator.clipboard.writeText(emoji.emoji).then(() => {
                    this.$message({
                        message: '文本已复制',
                        type: 'success'
                    });
                    const {ipcRenderer} = window.require('electron');
                    ipcRenderer.send('type-text', emoji.emoji);
                }, function () {
                    console.log('文件复制失败！');
                });
            },
            faceBtnClick(){
                this.facePanelShow=!this.facePanelShow;
            },
            openTopHuashu() {
                this.huashuTopBarShow = !this.huashuTopBarShow;
                if (this.huashuTopBarShow) {
                    this.showHuashuList = this.huashuList;
                    localStorage.removeItem("huashuTopBarHide");
                } else {
                    this.showHuashuList = this.huashuList.filter((huashu) => {
                        return !huashu.isTop
                    });
                    localStorage.setItem("huashuTopBarHide", 1);
                }
                this.updateCellStyle();
            },
            chooseHuashuTypeCancel() {
                this.showChooseHuashuTypeDialog = false;
            },
            async chooseHuashuTypeConfirm() {
                const loading = Loading.service({
                    lock: true,
                    text: '加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let params = {
                    speechId: this.speechId,
                    labelId: this.typeList[this.typeSelIdx].labelId,
                    id: this.menuData.id,
                    targetLabelId: this.typeList[this.chooseTypeSelIdx].labelId,
                }
                console.log("huashuTypeSave params=", params);
                let resp = await this.$http.moveHuashuType(params)
                if (resp.code == 200) {
                    let huashuIdx = this.huashuList.findIndex((huashu) => {
                        return huashu.id == this.menuData.id
                    });
                    this.huashuList.splice(huashuIdx, 1);

                } else {
                    this.$message({
                        message: resp.message,
                        type: 'warning'
                    });
                }
                this.showChooseHuashuTypeDialog = false;
                loading.close();
            },
            //选择话术分类
            chooseHuashuTypeClick(idx) {
                this.chooseTypeSelIdx = idx;
            },
            convertFileData(text) {
                const regex = /【([^【】]+)】(?:\n\n((?:■[^【]+(?:\n[^【■]+)*)*))/g;
                let matches;
                const result = [];

                while ((matches = regex.exec(text)) !== null) {
                    const category = matches[1].trim();
                    const categoryText = matches[2].trim();

                    // 解析分类中的标题和内容
                    const categoryRegex = /■([^【\n]+)\n([^■]*)/g;
                    let categoryMatches;
                    const categoryData = [];

                    while ((categoryMatches = categoryRegex.exec(categoryText)) !== null) {
                        const title = categoryMatches[1].trim();
                        const content = categoryMatches[2].trim().replace(/\n+/g, '\n');
                        categoryData.push({
                            title,
                            content
                        });
                    }

                    // 添加分类到结果数组
                    result.push({
                        type: category,
                        sub: categoryData
                    });
                }
                console.log('convertFileData result:', result)
                return result;
            },
            paneresizestop(e) {
                localStorage.setItem('typeListWidth', e.clientWidth)
                this.typeListWidth = e.clientWidth;
            },
            async cancelSearch(){
                this.isSeaching = false;
                this.huashuPage = 1;
                this.huashuList = [];
                this.keywords = '';
                this.huashuListLoadend = false;
                this.fetchHuashuList();
            },
            async searchBtnClick() {
                this.isSeaching = true;
                this.searchPage = 1;
                this.huashuList = [];
                this.searchLoadend = false;
                this.searchHuashu();
            },
            async localSearchHuashu(){
                return new Promise(async (resolve,reject)=>{
                    console.log("localSearchHuashu...");
                    // let localHuashuList = await dbService.search(this.keywords,'huashuList')
                    // this.localHuashuListData = await dbService.getAllData("huashuList")
                    let localHuashuListData=this.localHuashuListData;
                    console.log("localHuashuList:",localHuashuListData);
                    let options= {
                        keys: ['title', 'speechText', 'allText'], // 多个搜索键
                        threshold: 0.6, // 阈值控制匹配的敏感度
                        shouldSort: true, // 是否对结果进行排序
                        location: 0, // 匹配的位置，0 表示开头匹配
                        distance: 100, // 搜索的最大距离
                        minMatchCharLength: 2, // 最小匹配字符长度
                    }
                    const fuse = new Fuse(localHuashuListData, options);
                    let localHuashuList = fuse.search(this.keywords).map((val)=>{
                        return val.item
                    });
                    console.log("localSearchHuashu result:",localHuashuList);
                    if(!localHuashuList){
                        return;
                    }
                    localHuashuList = localHuashuList.map((val) => {
                        return this.decorateHuashuItem(val);
                    })
                    this.huashuList.splice(this.huashuList.length, 0, ...localHuashuList);
                    if (this.huashuTopBarShow) {
                        this.showHuashuList = this.huashuList;
                    } else {
                        this.showHuashuList = this.huashuList.filter((huashu) => {
                            return !huashu.isTop
                        });
                    }
                })
            },
            async searchHuashu() {
                if(false){
                    //检查增量更新搜索
                    await this.huashuCheckIncrement();
                    if(this.searchType!=3&&!(this.isAISearch&&this.aiSearchType==2)){
                        await this.localSearchHuashu();
                        return;
                    }
                }

                this.searchLoading = true;
                let params = {
                    page: this.searchPage,
                    pageSize: this.searchPageSize,
                    speechId: this.speechId,
                    keyword: this.keywords,
                    isAIEnable: this.isAISearch&&this.aiSearchType==2 ? 1 : 0
                }
                console.log("huashuSearch params:", params);
                let resp = await this.$http.huashuSearch(params);
                console.log("huashuSearch resp:", resp);
                if (resp.code == 200) {
                    if (resp.data.array.length) {
                        resp.data.array = resp.data.array.map((val) => {
                            return this.decorateHuashuItem(val);
                        })
                        this.huashuList.splice(this.huashuList.length, 0, ...resp.data.array);
                        if (this.huashuTopBarShow) {
                            this.showHuashuList = this.huashuList;
                        } else {
                            this.showHuashuList = this.huashuList.filter((huashu) => {
                                return !huashu.isTop
                            });
                        }
                    }
                    if (resp.data.array.length < this.searchPageSize) {
                        this.searchLoadend = true;
                    } else {
                        this.searchPage++;
                    }
                }
                this.searchLoading = false;
            },
            rightMenuCellClick(idx) {
                if (this.huashuTeamList[this.teamSelIdx] && this.huashuTeamList[this.teamSelIdx].roleId == 0) {
                    this.$message({
                        message: '无权限',
                        type: 'warning'
                    });
                    return;
                }

                if (this.menuCellList[idx].action == 'removeHuashu') {
                    //删除话术
                    this.removeHuashu()
                }
                else if (this.menuCellList[idx].action == 'insertHuashu') {
                    //新增话术
                    this.addHuashu();
                }
                else if (this.menuCellList[idx].action == 'editHuashu') {
                    //编辑话术
                    this.editHuashu();
                } else if (this.menuCellList[idx].action == 'setHuashuTop') {
                    //固定置顶话术
                    this.setHuashuTop();
                } else if (this.menuCellList[idx].action == 'setHuashuNoTop') {
                    //取消置顶话术
                    this.setHuashuNoTop();
                } else if (this.menuCellList[idx].action == 'moveHuashu2First') {
                    //刷到顶部
                    this.moveHuashu2First();
                } else if (this.menuCellList[idx].action == 'moveHuashuType') {
                    //移动话术类型
                    this.moveHuashuType();
                } else if (this.menuCellList[idx].action == 'editHuashuType') {
                    //编辑话术类型
                    this.editHuashuType();
                } else if (this.menuCellList[idx].action == 'refreshHuashuType') {
                    //刷新话术类型
                    this.refreshHuashuType();
                } else if (this.menuCellList[idx].action == 'autoSend') {
                    //逐条发送
                    this.autoSend();
                } else if (this.menuCellList[idx].action == 'sortHuashuType') {
                    this.openSortDialog();
                }
            },
            tabClick(idx) {
                this.isSeaching = false;
                this.keywords = "";
                this.tabIndex = idx;
                this.xiaoguanShow = false;
                //切换到备忘Tab时刷新备忘列表
                if (idx === 2) {
                    this.$nextTick(() => {
                        if (this.$refs.memoList) {
                            this.$refs.memoList.refresh();
                        }
                    });
                }
                //切换到剪贴板Tab时刷新剪贴板历史
                if (idx === 3) {
                    this.$nextTick(() => {
                        if (this.$refs.clipboardHistory) {
                            this.$refs.clipboardHistory.refresh();
                        }
                    });
                }
                this.fetchData();
            },
            // ── 首页顶部 Tab：保留哪些 + 顺序 + 长按拖动排序 ──
            // 把一份配置（key 数组 / tab 对象数组 / null）落到顶栏上
            applyHomeTopTabs(raw) {
                this.topTabOrder = normalizeHomeTopTabs(raw);
                this.ensureActiveTabVisible();
            },
            // 当前选中的页签被设置页隐藏掉时，自动切到第一个保留下来的页签，
            // 否则会出现「顶栏一个都没高亮、内容区还停在已隐藏页签」的割裂状态
            ensureActiveTabVisible() {
                if (!this.topTabOrder.length) return;
                const visible = this.topTabOrder;
                const activeStillVisible = this.xiaoguanShow
                    ? visible.some((t) => t.type === 'xiaoguan')
                    : visible.some((t) => t.type !== 'xiaoguan' && t.index === this.tabIndex);
                if (activeStillVisible) return;
                const first = visible.filter((t) => t.type !== 'xiaoguan')[0] || visible[0];
                if (first.type === 'xiaoguan') {
                    this.xiaoguanShow = true;
                } else {
                    this.xiaoguanShow = false;
                    this.tabIndex = first.index;
                }
                // 组件还没挂载完（created 阶段）不要拉数据，等 activated 里的 fetchData
                if (this.homeMounted) this.fetchData();
            },
            loadTopTabOrder() {
                // 设置页改的配置优先（换电脑登录后云端也会把它同步回来），
                // 其次才是老版本长按排序写在本地的配置
                const fromSetting = homeTabsFromSettingInfo(this.$store.state.settingInfo);
                this.applyHomeTopTabs(fromSetting || loadLocalHomeTopTabs());
            },
            saveTopTabOrder() {
                const order = this.topTabOrder.map((t) => t.key);
                saveLocalHomeTopTabs(order);
                // 回写到设置项：设置页「首页页签」要看到同一个顺序，换电脑也能从云端恢复
                this.$store.commit('modifyHomeTopTabs', order);
                const info = this.$store.state.settingInfo;
                // 只有设置项已经完整加载时才回写主进程：
                // 主进程 saveSettingInfo 是「整份覆盖」，发一份残缺的过去会把其它设置打回默认值
                if (window.require && info && Array.isArray(info.applist) && Array.isArray(info.partSplitType)) {
                    try {
                        const { ipcRenderer } = window.require('electron');
                        ipcRenderer.send('saveSettingInfo', JSON.stringify(info));
                    } catch (e) {}
                }
            },
            saveActiveTabState() {
                try {
                    localStorage.setItem("wminput:activeTabIndex", String(this.tabIndex));
                    localStorage.setItem("wminput:activeXiaoguan", this.xiaoguanShow ? "1" : "0");
                } catch (e) {}
            },
            restoreActiveTabState() {
                try {
                    const ti = localStorage.getItem("wminput:activeTabIndex");
                    if (ti) {
                        const n = parseInt(ti, 10);
                        if (n === 0 || n === 1 || n === 2 || n === 3 || n === 4) this.tabIndex = n;
                    }
                    this.xiaoguanShow = localStorage.getItem("wminput:activeXiaoguan") === "1";
                    if (this.xiaoguanShow) {
                        this.fetchProductList();
                    }
                } catch (e) {}
                // 上次停在的页签这次可能已经被设置页去掉了，兜一下
                this.ensureActiveTabVisible();
            },
            topTabIsActive(tab) {
                if (tab.type === 'xiaoguan') return this.xiaoguanShow;
                return this.tabIndex === tab.index && !this.xiaoguanShow;
            },
            topTabItemClass(tab) {
                return this.topTabIsActive(tab) ? 'topLLItem topLLItemSel' : 'topLLItem';
            },
            topTabDragStyle(tab) {
                if (this.topTabDrag.active && this.topTabDrag.key === tab.key) {
                    return {
                        opacity: '0.55',
                        transform: 'scale(1.08)',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                        borderRadius: '6px',
                        cursor: 'grabbing',
                        zIndex: 10,
                    };
                }
                return {};
            },
            topTabClick(tab) {
                if (this.topTabSuppressClick || this.topTabDrag.active) return;
                if (tab.type === 'xiaoguan') {
                    this.toggleXiaoguanKeyboard();
                } else {
                    this.tabClick(tab.index);
                }
            },
            onTopTabMouseDown(e, tab) {
                if (e.button !== 0) return;
                this.clearTopTabLongPress();
                this.topTabPress = { x: e.clientX, y: e.clientY, key: tab.key };
                this.topTabLongPressTimer = setTimeout(() => {
                    this.topTabLongPressTimer = null;
                    this.topTabPress = null;
                    this.topTabDrag = { active: true, key: tab.key };
                    if (this.$refs.topSubP) {
                        this.$refs.topSubP.style.overflowX = 'hidden';
                    }
                }, 500);
            },
            clearTopTabLongPress() {
                if (this.topTabLongPressTimer) {
                    clearTimeout(this.topTabLongPressTimer);
                    this.topTabLongPressTimer = null;
                }
            },
            onTopTabDocMove(e) {
                // 尚未长按：位移过大则取消长按，按普通点击处理
                if (this.topTabPress) {
                    const dx = e.clientX - this.topTabPress.x;
                    const dy = e.clientY - this.topTabPress.y;
                    if (Math.abs(dx) > 6 || Math.abs(dy) > 6) {
                        this.clearTopTabLongPress();
                        this.topTabPress = null;
                    }
                    return;
                }
                if (!this.topTabDrag.active) return;
                const container = this.$refs.topLLP;
                if (!container) return;
                const items = container.querySelectorAll('.topLLItem');
                const fromIndex = this.topTabOrder.findIndex((t) => t.key === this.topTabDrag.key);
                if (fromIndex < 0 || !items.length) return;
                let targetIndex = fromIndex;
                const firstRect = items[0].getBoundingClientRect();
                if (e.clientX < firstRect.left) {
                    targetIndex = 0;
                } else {
                    for (let i = 0; i < items.length; i++) {
                        const r = items[i].getBoundingClientRect();
                        if (e.clientX > r.left + r.width / 2) targetIndex = i;
                    }
                }
                if (targetIndex !== fromIndex) {
                    const list = this.topTabOrder.slice();
                    const [item] = list.splice(fromIndex, 1);
                    list.splice(targetIndex, 0, item);
                    this.topTabOrder = list;
                }
            },
            onTopTabDocUp() {
                const wasDragging = this.topTabDrag.active;
                const wasPressed = !!this.topTabPress || !!this.topTabLongPressTimer;
                this.clearTopTabLongPress();
                this.topTabPress = null;
                if (!wasDragging && !wasPressed) return;
                if (wasDragging) {
                    this.topTabDrag = { active: false, key: null };
                    this.topTabSuppressClick = true;
                    setTimeout(() => {
                        this.topTabSuppressClick = false;
                    }, 0);
                    if (this.$refs.topSubP) {
                        this.$refs.topSubP.style.overflowX = 'auto';
                    }
                    this.saveTopTabOrder();
                }
            },
            importHuashu() {
                this.$router.push({
                    path: '/huashuImport',
                    query: {
                        speechId: this.speechId,
                        labelId: this.labelId,
                        teamName: this.huashuTeamList[this.teamSelIdx].showName
                    }
                })
            },
            addHuashuType() {
                this.$prompt('', '添加分类', {
                    confirmButtonText: '保存',
                    cancelButtonText: '取消',
                    inputPattern: /^.+$/,
                    inputErrorMessage: '分类名称不能为空'
                }).then(async ({
                    value
                }) => {
                    let params = {
                        speechId: this.speechId,
                        labelName: value
                    }
                    console.log("huashuTypeSave params=", params);
                    let resp = await this.$http.huashuTypeSave(params)
                    if (resp.code == 200) {
                        console.log("huashuTypeSave resp:", resp);
                        this.typeList.splice(this.typeList.length, 0, resp.data.object)
                        this.huashuClick(0);
                    } else {
                        this.$message({
                            message: resp.message,
                            type: 'warning'
                        });
                    }
                }).catch(() => {});
            },
            addHuashu() {
                if(!this.labelId){
                    this.$message({
                        message: '请先创建分类',
                        type: 'warning'
                    });
                    return;
                }

                let team = this.huashuTeamList[this.teamSelIdx];
                if (team.roleId == 0) {
                    this.$message({
                        message: "无权限操作此话术",
                        type: 'warning'
                    });
                    return;
                }

                if (localStorage.getItem("editHuashuData")) {
                    localStorage.removeItem("editHuashuData")
                }
                // this.$router.push({
                //     path: '/huashuEdit',
                //     query: {
                //         speechId: this.speechId,
                //         labelId: this.labelId
                //     }
                // })
                if(window.require){
                    const {ipcRenderer} = window.require('electron');
                    ipcRenderer.send('openHuashuEdit', JSON.stringify({
                        speechId: this.speechId,
                        labelId: this.labelId,
                        
                    }));
                }
            },
            // 剪贴板列表点“添加到话术”：先弹出团队选择弹框（必选），
            // 选完团队后还要选该团队下的话术分类，最后才打开添加话术窗口。
            // 文本/图片/文件都走同一条挑团队+分类的流程，区别只在最后带进窗口的内容是文案还是媒体。
            async onClipboardAddToHuashu(item) {
                if (!item) return;
                const type = item.type || 'text';
                if (type === 'text' && !item.text) {
                    this.$message({
                        message: '内容为空，无法添加到话术',
                        type: 'warning'
                    });
                    return;
                }
                if (type === 'image' && !item.imagePath) {
                    this.$message({
                        message: '图片已失效，无法添加到话术',
                        type: 'warning'
                    });
                    return;
                }
                if (type === 'file' && !(item.files || []).length) {
                    this.$message({
                        message: '文件已失效，无法添加到话术',
                        type: 'warning'
                    });
                    return;
                }
                this.resetClipboardAdd();
                if (type === 'text') {
                    this.clipboardHuashuText = item.text;
                } else {
                    this.clipboardHuashuMedia = this.buildClipboardHuashuMedia(item);
                }
                this.clipboardAddStep = "team";
                this.isSeaching = false;
                this.xiaoguanShow = false;
                this.clipboardTeamDialogShow = true;
                if (!this.huashuTeamList.length) {
                    //团队列表还没加载过（比如直接进剪贴板Tab），先把团队拉回来，避免弹框里没有团队可选
                    this.clipboardTeamLoading = true;
                    try {
                        await Promise.race([
                            this.fetchHuashuTeamList(),
                            new Promise((resolve) => setTimeout(resolve, 3000))
                        ]);
                    } finally {
                        this.clipboardTeamLoading = false;
                    }
                }
            },
            // 剪贴板媒体条目 -> 传给“添加话术”窗口的最小载荷。
            // 添加话术窗口是另一个 BrowserWindow，File 对象不能跨进程传，
            // 所以这里只把落盘路径带过去，由窗口那边读盘重建 File
            //（见 HuashuEdit.applyPrefillMedia）。也顺带避免了几百 MB 的文件走 base64 IPC。
            buildClipboardHuashuMedia(item) {
                if (item.type === 'image') {
                    return {
                        type: 'image',
                        imagePath: item.imagePath
                    };
                }
                return {
                    type: 'file',
                    files: (item.files || []).map((f) => ({
                        path: f.path,
                        name: f.name
                    }))
                };
            },
            //清空剪贴板“添加到话术”整条流程的状态（分类列表留着，避免弹框关闭动画期间闪空）
            resetClipboardAdd() {
                this.clipboardAddStep = "";
                this.clipboardHuashuText = "";
                this.clipboardHuashuMedia = null;
                this.clipboardTeamLoading = false;
                this.clipboardTypeLoading = false;
                this.clipboardTypeDialogShow = false;
                this.clipboardTeamTypeSelIdx = 0;
                this.clipboardTargetTeamIdx = -1;
            },
            onClipboardTeamDialogClose() {
                //关闭团队弹框且不是在往“选分类”走，说明这次不添加了，清掉待添加文案
                if (this.clipboardAddStep === "team") {
                    this.resetClipboardAdd();
                }
            },
            onClipboardTypeDialogClose() {
                //关闭分类弹框且不是选完分类去打开添加话术窗口，说明这次不添加了
                if (this.clipboardAddStep === "type") {
                    this.resetClipboardAdd();
                }
            },
            // 剪贴板“添加到话术”第一步：选团队，选完拉该团队的话术分类，进入第二步
            async clipboardTeamItemClick(idx) {
                let team = this.huashuTeamList[idx];
                if (!team) return;
                if (team.roleId == 0) {
                    this.$message({
                        message: "无权限操作此话术",
                        type: 'warning'
                    });
                    return;
                }
                this.clipboardTargetTeamIdx = idx;
                this.clipboardTeamTypeList = [];
                this.clipboardTeamTypeSelIdx = 0;
                //先切到“选分类”步骤再关团队弹框，避免 close 回调把待添加文案清掉
                this.clipboardAddStep = "type";
                this.clipboardTeamDialogShow = false;
                this.clipboardTypeDialogShow = true;
                await this.loadClipboardTeamTypeList(idx);
            },
            clipboardTypeItemClick(idx) {
                this.clipboardTeamTypeSelIdx = idx;
            },
            // 查询指定团队下的分类列表（与共享话术页一致：过滤掉该团队成员不可见的分类）
            async loadClipboardTeamTypeList(teamIdx) {
                const team = this.huashuTeamList[teamIdx];
                if (!team) {
                    this.clipboardTeamTypeList = [];
                    return;
                }
                this.clipboardTypeLoading = true;
                try {
                    if (String(this.speechId) === String(team.speechId) && this.typeList.length) {
                        //就是当前团队：直接复用已经按 hideLabelIds 过滤过的分类
                        this.clipboardTeamTypeList = this.typeList.slice();
                        return;
                    }
                    const [detailResp, typeResp] = await Promise.all([
                        this.$http.fetchHuashuTeamDetail({
                            speechId: team.speechId
                        }),
                        this.$http.qryHuashuTypeList({
                            page: 1,
                            pageSize: this.typePageSize,
                            speechId: team.speechId
                        })
                    ]);
                    let arr = (typeResp && typeResp.code === 200 && typeResp.data && typeResp.data.array) ?
                        typeResp.data.array : [];
                    const teamInfo = (detailResp && detailResp.code === 200 && detailResp.data) ?
                        detailResp.data.object : null;
                    arr = this.filterHideTypeList(arr, teamInfo);
                    this.clipboardTeamTypeList = arr;
                } catch (e) {
                    console.log("[clipboard→huashu] loadClipboardTeamTypeList error:", e);
                    this.clipboardTeamTypeList = [];
                } finally {
                    this.clipboardTypeLoading = false;
                }
            },
            //按团队成员可见范围过滤分类（hideLabelIds）
            filterHideTypeList(typeArr, teamInfo) {
                let arr = typeArr || [];
                if (!teamInfo || !teamInfo.hideLabelIds || teamInfo.roleId == 2) {
                    return arr;
                }
                try {
                    const hideLabelIds = JSON.parse(teamInfo.hideLabelIds) || [];
                    if (!hideLabelIds.length) return arr;
                    return arr.filter((typeItem) => {
                        return !hideLabelIds.some((hideId) => String(hideId) === String(typeItem.labelId));
                    });
                } catch (e) {
                    return arr;
                }
            },
            // 剪贴板“添加到话术”第二步：确认分类，切到该团队+分类后打开添加话术窗口
            async clipboardTypeConfirm() {
                const team = this.huashuTeamList[this.clipboardTargetTeamIdx];
                const type = this.clipboardTeamTypeList[this.clipboardTeamTypeSelIdx];
                const text = this.clipboardHuashuText;
                const media = this.clipboardHuashuMedia;
                if (!team || !type) return;
                //先结束流程再关弹框，避免 close 回调把文案清掉
                this.clipboardAddStep = "";
                this.clipboardTypeDialogShow = false;
                //切到目标团队/分类，保证主界面列表与新增话术的位置一致
                if (String(this.speechId) !== String(team.speechId) || !this.typeList.length) {
                    await this.teamItemClick(this.clipboardTargetTeamIdx);
                }
                const pos = this.typeList.findIndex((item) => {
                    return String(item.labelId) === String(type.labelId);
                });
                if (pos < 0) {
                    this.$message({
                        message: '该分类已不可用，请重新选择',
                        type: 'warning'
                    });
                    this.resetClipboardAdd();
                    return;
                }
                if (String(this.labelId) !== String(type.labelId)) {
                    this.huashuClick(pos);
                } else {
                    this.typeSelIdx = pos;
                }
                this.openHuashuEditWith(text, media);
                this.resetClipboardAdd();
            },
            // 打开添加话术窗口，并把剪贴板带过来的文案/图片/文件带进去。
            // text 与 media 不会同时有值（一条剪贴板记录只可能是其中一种类型）
            openHuashuEditWith(text, media) {
                if (!window.require) {
                    this.$message({
                        message: '请在客户端中使用该功能',
                        type: 'warning'
                    });
                    return;
                }
                if (localStorage.getItem("editHuashuData")) {
                    localStorage.removeItem("editHuashuData");
                }
                const {ipcRenderer} = window.require('electron');
                const prefillText = text == null ? '' : String(text);
                const prefillMedia = media || null;
                console.log("[clipboard→huashu] openHuashuEdit", {
                    speechId: this.speechId,
                    labelId: this.labelId,
                    prefillLen: prefillText.length,
                    prefillMedia: prefillMedia ? prefillMedia.type : 'none'
                });
                try {
                    window.require('fs').appendFileSync('/tmp/wminput-huashu.log',
                        new Date().toISOString() + ' [main] openHuashuEdit speechId=' + this.speechId +
                        ' labelId=' + this.labelId + ' prefillLen=' + prefillText.length +
                        ' prefillMedia=' + (prefillMedia ? prefillMedia.type : 'none') +
                        ' preview=' + JSON.stringify(prefillText.slice(0, 20)) + '\n');
                } catch (e) {}
                ipcRenderer.send('openHuashuEdit', JSON.stringify({
                    speechId: this.speechId,
                    labelId: this.labelId,
                    prefillText: prefillText,
                    prefillMedia: prefillMedia
                }));
            },
            async removeHuashu() {
                if (this.huashuTeamList[this.teamSelIdx].roleId != 0) {
                    this.$confirm('确定删除？', '', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(async () => {
                        let params = {
                            speechId: this.speechId,
                            labelId: this.menuData.labelId,
                            id: this.menuData.id,
                        }
                        console.log("huashuRemove params=", params);
                        let resp = await this.$http.huashuRemove(params)
                        if (resp.code == 200) {
                            console.log("huashuRemove resp:", resp);
                            //用 id 定位待删除话术，不能用 showHuashuList 的下标去操作 huashuList（下标错位会删错话术）
                            let removeIdx = this.huashuList.findIndex((huashu) => {
                                return huashu.id == this.menuData.id
                            });
                            if (removeIdx > -1) {
                                this.huashuList.splice(removeIdx, 1);
                            }
                            let tempList = this.huashuList.map((val, idx) => {
                                val.idx = idx;
                                return val;
                            })
                            this.huashuList = tempList;
                        } else {
                            this.$message({
                                message: resp.message,
                                type: 'warning'
                            });
                        }
                    }).catch(() => {

                    });
                } else {
                    this.$message({
                        message: "无权限操作此话术",
                        type: 'warning'
                    });
                }
            },
            editHuashu() {
                if (this.huashuTeamList[this.teamSelIdx].roleId != 0) {
                    if(window.require){
                        const {ipcRenderer} = window.require('electron');
                        ipcRenderer.send('openHuashuEdit', JSON.stringify({
                            speechId: this.speechId,
                            labelId: this.menuData.labelId,
                            editHuashuData: this.menuData
                        }));
                    }else{
                        let editData = Object.assign({}, this.menuData, {speechId: this.speechId});
                        localStorage.setItem("editHuashuData", JSON.stringify(editData))
                        this.$router.push({
                            path: '/huashuEdit',
                            query: {
                                speechId: this.speechId,
                                isWeb:true,
                                // labelId: this.labelId,
                                // editHuashuData: this.menuData
                            }
                        })
                    }
                } else {
                    this.$message({
                        message: "无权限操作此话术",
                        type: 'warning'
                    });
                }
            },
            editHuashuType() {
                console.log("this.menuData:", this.menuData);
                this.$prompt('', '修改分类', {
                    confirmButtonText: '保存',
                    cancelButtonText: '取消',
                    inputPattern: /^.+$/,
                    inputErrorMessage: '分类名称不能为空'
                }).then(async ({
                    value
                }) => {
                    let rightIdx = this.typeList.findIndex(val => val.labelId == this.menuData.labelId)
                    let type = this.typeList[rightIdx];
                    let params = {
                        speechId: this.speechId,
                        labelName: value,
                        labelId: type.labelId,
                    }
                    console.log("huashuTypeSave params=", params);
                    let resp = await this.$http.huashuTypeSave(params)
                    if (resp.code == 200) {
                        console.log("huashuTypeSave resp:", resp);
                        type.labelName = value;
                        this.typeList.splice(rightIdx, 1, type)
                    } else {
                        this.$message({
                            message: resp.message,
                            type: 'warning'
                        });
                    }
                }).catch(() => {});
            },
            //话术刷到顶部
            async moveHuashu2First() {
                let params = {
                    speechId: this.speechId,
                    labelId: this.typeList[this.typeSelIdx].labelId,
                    id: this.menuData.id,
                }
                console.log("huashuRefreshTop params=", params);
                let resp = await this.$http.huashuRefreshTop(params);
                if (resp.code == 200) {
                    let huashuIdx = this.huashuList.findIndex((huashu) => {
                        return huashu.id == this.menuData.id
                    });
                    let huashuItem = this.huashuList[huashuIdx];
                    this.huashuList.splice(huashuIdx, 1);
                    if (!this.menuData.isTop) {
                        let huashuNoIsTopIdx = this.huashuList.findIndex((huashu) => {
                            return !huashu.isTop
                        });
                        this.huashuList.splice(huashuNoIsTopIdx, 0, huashuItem)
                    } else {
                        this.huashuList.splice(0, 0, huashuItem)
                    }
                }
            },
            //话术自动发送
            autoSend(){
                if(window.require){
                    const {ipcRenderer} = window.require('electron');
                    ipcRenderer.send('openAutoSend', JSON.stringify({
                        speechId: this.speechId,
                        labelId: this.menuData.labelId,
                        editHuashuData: this.menuData
                    }));
                }
            },
            //话术更新置顶
            setHuashuTop() {
                this.updateHuashuIsTop(1);
            },
            //话术取消置顶
            setHuashuNoTop() {
                this.updateHuashuIsTop(0);
            },
            //更新话术置顶状态
            async updateHuashuIsTop(isTop) {
                let params = {
                    speechId: this.speechId,
                    labelId: this.typeList[this.typeSelIdx].labelId,
                    id: this.menuData.id,
                    isTop: isTop
                }
                console.log("updateHuashuIsTop params=", params);
                let resp = await this.$http.updateHuashuIsTop(params);
                if (resp.code == 200) {
                    let huashuIdx = this.huashuList.findIndex((huashu) => {
                        return huashu.id == this.menuData.id
                    });
                    let huashuItem = this.huashuList[huashuIdx];
                    huashuItem.isTop = isTop;
                    this.huashuList.splice(huashuIdx, 1);
                    if (isTop) {
                        this.huashuList.splice(0, 0, huashuItem)
                    } else {
                        let huashuNoIsTopIdx = this.huashuList.findIndex((huashu) => {
                            return !huashu.isTop
                        });
                        this.huashuList.splice(huashuNoIsTopIdx, 0, huashuItem)
                    }
                }
            },
            //移动话术类型
            moveHuashuType() {
                this.showChooseHuashuTypeDialog = true;
            },
            //刷新话术类型
            async refreshHuashuType() {
                let params = {
                    speechId: this.speechId,
                    labelId: this.menuData.labelId,
                }
                console.log("huashuTypeRefreshTop params=", params);
                let resp = await this.$http.huashuTypeRefreshTop(params);
                if (resp.code == 200) {
                    let huashuTypeIdx = this.typeList.findIndex((huashuType) => {
                        return huashuType.labelId == this.menuData.labelId
                    });
                    let huashuTypeItem = this.typeList[huashuTypeIdx];
                    this.typeList.splice(huashuTypeIdx, 1);
                    this.typeList.splice(0, 0, huashuTypeItem)
                }
            },
            huashuItemMouseIn(e, item,idx){
                console.log("huashuItemMouseIn...");  
                this.huashuItemHoverIdx=idx;

                if(!this.hoverPreviewCheck){
                    return;
                }

                if(this.huashuItemHoverTimer){
                    return;
                }

                this.hoverShowing=true;
                let hoverPos = {
                    x:e.pageX,
                    y:e.pageY,
                };
                if(this.isHuashuItemHovering){
                    if(window.require){
                        const {ipcRenderer} = window.require('electron');
                        ipcRenderer.send('huashuItemHover', JSON.stringify({pos:hoverPos,text:item.allText}));
                    }
                    // return;
                }else{
                    // clearTimeout(this.huashuItemHoverTimer)
                    // this.huashuItemHoverTimer=null
                    this.huashuItemHoverTimer=setTimeout(()=>{   
                        this.isHuashuItemHovering=true;
                        if(window.require){
                            const {ipcRenderer} = window.require('electron');
                            ipcRenderer.send('huashuItemHover', JSON.stringify({pos:hoverPos,text:item.allText}));
                        }
                    },1000)
                }
            },
            huashuItemHover(e, item,idx){   
                
            },
            huashuItemMouseleave(){
                this.huashuItemHoverIdx=-1;          
                if(!this.hoverPreviewCheck){
                    return;
                }
                if(this.huashuItemHoverTimer){
                    clearTimeout(this.huashuItemHoverTimer)
                    this.huashuItemHoverTimer=null
                }
                if(window.require){
                    const {ipcRenderer} = window.require('electron');
                    ipcRenderer.send('huashuItemMouseleave');
                }
            },
            huashuListMouseleave(){
                this.huashuItemHoverIdx=-1; 
                if(!this.hoverPreviewCheck){
                    return;
                }
                if(this.huashuItemHoverTimer){
                    clearTimeout(this.huashuItemHoverTimer)
                    this.huashuItemHoverTimer=null
                }
                setTimeout(()=>{
                    this.isHuashuItemHovering=false
                    if(window.require){
                        const {ipcRenderer} = window.require('electron');
                        ipcRenderer.send('huashuItemMouseleave');
                    };
                },100)
            },
            hideMenu() {
                this.menuShow = false;
            },
            showMenu(e, item, idx) {
                console.log("showMenu e:", e);
                console.log("showMenu item:", item);
                // this.menuPos=[e.x,e.y-this.$refs.huashuList.scrollTop];
                this.menuPos = [e.x, e.y];
                this.menuData = item;
                this.menuData.idx = idx;
                if(!this.isSeaching){
                    this.menuCellList = [
                        {
                            label: '逐条发送',
                            action: 'autoSend'
                        },    
                        {
                            label: '编辑',
                            action: 'editHuashu'
                        },
                        {
                            label: '新增',
                            action: 'insertHuashu'
                        },
                        {
                            label: '刷到顶部',
                            action: 'moveHuashu2First'
                        },
                        {
                            label: '移动',
                            action: 'moveHuashuType'
                        },
                        {
                            label: '删除',
                            action: 'removeHuashu'
                        }
                    ]
                    if (!this.menuData.isTop) {
                        this.menuCellList.splice(2, 0, {
                            label: '固定置顶',
                            action: 'setHuashuTop'
                        })
                    } else {
                        this.menuCellList.splice(2, 0, {
                            label: '取消置顶',
                            action: 'setHuashuNoTop'
                        })
                    }
                }else{
                    this.menuCellList = [
                        {
                            label: '编辑',
                            action: 'editHuashu'
                        },
                        {
                            label: '删除',
                            action: 'removeHuashu'
                        }
                    ]
                    if (!this.menuData.isTop) {
                        this.menuCellList.splice(2, 0, {
                            label: '固定置顶',
                            action: 'setHuashuTop'
                        })
                    } else {
                        this.menuCellList.splice(2, 0, {
                            label: '取消置顶',
                            action: 'setHuashuNoTop'
                        })
                    }
                }
                this.menuShow = true;
            },
            showTypeMenu(e, item, idx) {
                console.log("showTypeMenu e:", e);
                console.log("showTypeMenu wenan:", item);
                this.menuPos = [e.x, e.y];
                this.menuData = item;
                this.menuData.idx = idx;
                this.menuCellList = [{
                        label: '修改',
                        action: 'editHuashuType'
                    },
                    {
                        label: '刷新',
                        action: 'refreshHuashuType'
                    },
                    {
                        label: '排序',
                        action: 'sortHuashuType'
                    }
                ]
                this.menuShow = true;
            },
            loginDailogClick() {
                this.$store.commit("modifyLoginDailogShow", !this.$store.state.loginDailogShow)
            },
            textShowClick(idx) {
                //关闭悬浮窗
                this.huashuItemMouseleave();

                if (this.tabIndex == 0) {
                    this.showHuashuList[idx].showBtn = this.showHuashuList[idx].showBtn == 'zhankai' ? 'shouqi' :
                        'zhankai'
                } else if (this.tabIndex == 1) {
                    this.wenanList[idx].showBtn = this.wenanList[idx].showBtn == 'zhankai' ? 'shouqi' : 'zhankai'
                }
            },
            typeOnScroll(e) {
                if (this.tabIndex == 0 && this.hushuTypeLoading || this.tabIndex == 1 && this.themeCategoryLoading) {
                    return;
                }

                let scrollHeight = e.target.scrollHeight;
                let clientHeight = e.target.clientHeight;
                let scrollTop = e.target.scrollTop;
                if (scrollHeight > clientHeight && scrollTop >= (scrollHeight - clientHeight - 5)) {
                    if (this.tabIndex == 0 && !this.typeListLoadend) {
                        this.fetchHuashuTypeList();
                    } else if (this.tabIndex == 1 && !this.themeCategoryLoadend) {
                        this.fetchWenanPackageCategoryList();
                    }
                }
            },
            huashuOnScroll(e) {
                if (this.tabIndex == 0 && (this.loading || this.searchLoading) || this.tabIndex == 1 && this
                    .wenanloading) {
                    return;
                }

                let scrollHeight = e.target.scrollHeight;
                let clientHeight = e.target.clientHeight;
                let scrollTop = e.target.scrollTop;
                if (scrollHeight > clientHeight && scrollTop >= (scrollHeight - clientHeight - 5)) {
                    if (this.tabIndex == 0 && !this.isSeaching && !this.huashuListLoadend) {
                        this.fetchHuashuList();
                    } else if (this.tabIndex == 0 && this.isSeaching && !this.searchLoadend) {
                        this.searchHuashu();
                    } else if (this.tabIndex == 1 && !this.wenanListLoadend) {
                        this.fetchWenanList();
                    }
                }
            },
            hideTeamList() {
                this.teamListShow = false;
            },
            async teamItemClick(idx) {
                this.isSeaching = false;
                this.keywords = "";
                this.teamSelIdx = idx;
                this.speechId = this.huashuTeamList[idx].speechId;
                localStorage.setItem("lastSelSpeechId", this.speechId)
                this.typePage = 1;
                this.typeSelIdx = 0;
                this.typeList = [];
                this.huashuPage = 1;
                this.huashuList = [];
                this.typeListLoadend = false;
                this.huashuListLoadend = false;
                await this.fetchHuashuTeamDetail();
                //必须先拿到当前团队的变量列表再拉话术，否则列表里的变量占位符替换不了
                await this.fetchHuashuValList();
                await this.fetchHuashuTypeList();
                this.teamListShow = false;
            },
            async themeItemClick(idx) {

                //切换文案包检查
                let params = {
                    themeId: this.themeList[idx].themeId
                }
                console.log("checkChangeWenanPackage params=", params);
                let resp = await this.$http.checkChangeWenanPackage(params)
                if (resp.code == 200) {
                    this.themeSelIdx = idx;
                    this.themeId = this.themeList[idx].themeId;
                    localStorage.setItem("lastSelThemeId", this.themeId)
                    this.themeCategoryPage = 1;
                    this.themeCategorySelIdx = 0;
                    this.themeCategoryList = [];
                    this.themeCategoryLoadend = false;
                    this.wenanPage = 1;
                    this.wenanList = [];
                    this.wenanListLoadend = false;
                    this.fetchWenanPackageCategoryList();
                    this.teamListShow = false;
                } else if (resp.code == 0) {
                    this.$message({
                        message: resp.message,
                        type: 'warning'
                    });
                } else if (resp.code == 8) {
                    this.$msgbox({
                        message: resp.message,
                        type: 'info'
                    });
                }
            },
            changeTeam() {
                this.teamListShow = true;
                this.xiaoguanShow = false;
            },
            toggleXiaoguanKeyboard() {
                this.teamListShow = false;
                this.xiaoguanShow = !this.xiaoguanShow;
                if (this.xiaoguanShow) {
                    this.fetchProductList();
                }
            },
            async fetchProductList() {
                try {
                    const resp = await this.$http.salesProductList({});
                    if (resp.code === 200 && resp.data && resp.data.array) {
                        this.productList = resp.data.array;
                    }
                } catch (e) {
                    console.log("获取产品列表失败:", e);
                }
            },
            hideXiaoguanKeyboard() {
                this.xiaoguanShow = false;
            },
            uploadScreenshot() {
                if (this.xkOcrLoading) return;
                if (this.$refs.xkScreenshotFile) {
                    this.$refs.xkScreenshotFile.click();
                }
            },
            validateImageFile(file) {
                if (!file) return '未获取到图片';
                if (!/^image\//.test(file.type)) return '请选择图片文件';
                if (file.size > OCR_IMAGE_MAX_SIZE) return '图片大小不能超过 5MB';
                return null;
            },
            readImageFileToBase64(file) {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(stripBase64(reader.result));
                    reader.onerror = () => reject(new Error('图片读取失败'));
                    reader.readAsDataURL(file);
                });
            },
            async handleImageFile(file) {
                const errMsg = this.validateImageFile(file);
                if (errMsg) {
                    this.$message({ message: errMsg, type: 'warning' });
                    return;
                }
                let base64 = '';
                try {
                    base64 = await this.readImageFileToBase64(file);
                } catch (e) {
                    this.$message({ message: '图片读取失败', type: 'warning' });
                    return;
                }
                if (!base64) {
                    this.$message({ message: '图片读取失败', type: 'warning' });
                    return;
                }
                this.doRecognizeScreenshot(base64);
            },
            onScreenshotChange(e) {
                const file = e.target.files && e.target.files[0];
                if (!file) return;
                // 重置 input，允许重复选择同一张图
                e.target.value = "";
                this.handleImageFile(file);
            },
            onPasteQuestion(e) {
                const items = e.clipboardData && e.clipboardData.items;
                if (!items) return;
                let imageFile = null;
                for (let i = 0; i < items.length; i++) {
                    const item = items[i];
                    if (item.type && item.type.indexOf('image/') === 0) {
                        imageFile = item.getAsFile && item.getAsFile();
                        break;
                    }
                }
                if (!imageFile) return; // 无图片，走默认文本粘贴
                e.preventDefault();
                this.handleImageFile(imageFile);
            },
            async doRecognizeScreenshot(base64) {
                if (this.xkOcrLoading) return;
                this.xkOcrLoading = true;
                try {
                    const text = await recognizeImageText(base64);
                    if (text && text.trim()) {
                        this.xiaoguanQuestion = text;
                        this.$message({ message: '识别成功', type: 'success' });
                    } else {
                        this.$message({ message: '未识别到文字', type: 'warning' });
                    }
                } catch (err) {
                    console.log('截图 OCR 识别失败:', err);
                    this.$message({ message: (err && err.message) || '识别失败，请重试', type: 'warning' });
                } finally {
                    this.xkOcrLoading = false;
                }
            },
            onQuestionInputFocus() {
                if (this.xkPromptingImage) return;
                let clipboardApi = null;
                try {
                    clipboardApi = window.require && window.require('electron').clipboard;
                } catch (_) {}

                if (clipboardApi) {
                    let hasImage = false;
                    try {
                        const img = clipboardApi.readImage();
                        hasImage = img && !img.isEmpty();
                    } catch (_) {}

                    if (hasImage) {
                        this.promptRecognizeClipboardImage(clipboardApi);
                    } else {
                        const text = clipboardApi.readText();
                        if (text) {
                            this.xiaoguanQuestion = text;
                        }
                        // 无图片也无文字 → 静默，不弹提示，用户可自行输入
                    }
                    return;
                }
                this.checkClipboardInBrowser();
            },
            promptRecognizeClipboardImage(clipboardApi) {
                this.xkPromptingImage = true;
                this.$confirm('检测到剪切板中有图片，是否进行识别？', '提示', {
                    confirmButtonText: '识别',
                    cancelButtonText: '取消',
                    type: 'info',
                }).then(() => {
                    this.recognizeClipboardImage(clipboardApi);
                }).catch(() => {
                    // 用户取消，静默
                }).finally(() => {
                    // 对话框关闭后延迟复位，避免焦点回到输入框时再次触发
                    setTimeout(() => {
                        this.xkPromptingImage = false;
                    }, 300);
                });
            },
            recognizeClipboardImage(clipboardApi) {
                try {
                    const img = clipboardApi.readImage();
                    if (!img || img.isEmpty()) {
                        this.$message({ message: '未读取到图片', type: 'warning' });
                        return;
                    }
                    const base64 = stripBase64(img.toDataURL());
                    if (!base64) {
                        this.$message({ message: '图片读取失败', type: 'warning' });
                        return;
                    }
                    this.doRecognizeScreenshot(base64);
                } catch (e) {
                    console.log('读取剪切板图片失败:', e);
                    this.$message({ message: '读取剪切板图片失败', type: 'warning' });
                }
            },
            async checkClipboardInBrowser() {
                let hasImage = false;
                try {
                    if (navigator.clipboard && navigator.clipboard.read) {
                        const items = await navigator.clipboard.read();
                        hasImage = items.some(it => (it.types || []).some(t => /^image\//.test(t)));
                    }
                } catch (_) {}

                if (hasImage) {
                    this.xkPromptingImage = true;
                    this.$confirm('检测到剪切板中有图片，是否进行识别？', '提示', {
                        confirmButtonText: '识别',
                        cancelButtonText: '取消',
                        type: 'info',
                    }).then(async () => {
                        try {
                            const items = await navigator.clipboard.read();
                            for (const it of items) {
                                const imgType = (it.types || []).find(t => /^image\//.test(t));
                                if (imgType) {
                                    const blob = await it.getType(imgType);
                                    this.handleImageFile(new File([blob], 'clipboard.png', { type: imgType }));
                                    break;
                                }
                            }
                        } catch (e) {
                            this.$message({ message: '读取剪切板图片失败', type: 'warning' });
                        }
                    }).catch(() => {}).finally(() => {
                        setTimeout(() => {
                            this.xkPromptingImage = false;
                        }, 300);
                    });
                    return;
                }

                try {
                    const text = await navigator.clipboard.readText();
                    if (text) {
                        this.xiaoguanQuestion = text;
                    }
                } catch (_) {}
            },
            async xkCategoryClick(idx) {
                this.xkCategorySelIdx = idx;
                if (this.xkSegmentTab === 1 && this.xkSelProductIdx < 0) {
                    this.$message({ message: '未选择产品无法使用开场白，请去app上添加产品', type: 'warning' });
                    return;
                }
                if (this.xkSegmentTab === 0 && !this.xiaoguanQuestion.trim()) {
                    this.$message({ message: '请先填入问题', type: 'warning' });
                    return;
                }
                this.xkCategoryLoading = true;
                try {
                    const currentList = this.xkCurrentCategoryList;
                    const params = {
                        question: this.xiaoguanQuestion || currentList[idx].label,
                        talk_type: this.xkSegmentTab === 0 ? 40 : 41,
                        is_stream: 1,
                        keyword: currentList[idx].key,
                    };
                    if (this.xkSelProductIdx >= 0 && this.productList[this.xkSelProductIdx]) {
                        params.pid = this.productList[this.xkSelProductIdx].pid;
                    }
                    if (this.xkSelTeamIdx >= 0 && this.huashuTeamList[this.xkSelTeamIdx]) {
                        params.speechId = this.huashuTeamList[this.xkSelTeamIdx].speechId;
                    }
                    console.log("销冠键盘 AI对话 请求参数:", params);
                    const { ipcRenderer } = window.require("electron");
                    const resp = await ipcRenderer.invoke("keyboard-ai-chat", params);
                    console.log("销冠键盘 AI对话 返回结果:", resp);
                    if (resp?.code !== 200) {
                        this.$message({ message: resp?.message || "请求失败，请重试", type: "warning" });
                    } else {
                        const answer = resp?.data?.object?.answer;
                        if (answer) {
                            ipcRenderer.send("type-text", answer);
                        }
                    }
                } catch (e) {
                    console.log("销冠键盘 AI对话 请求失败:", e);
                }
                this.xkCategoryLoading = false;
            },
            // 销冠键盘现在是内容区里的普通页签（不再是用 z-index 压住弹窗的浮层），
            // 所以打开“切换产品 / 选择团队”弹窗时不用再先把它隐藏，
            // 否则弹窗背后会闪出上一个页签的内容
            openProductDialog() {
                this.showProductDialog = true;
            },
            openHuashuSelectDialog() {
                this.showHuashuSelectDialog = true;
            },
            onProductDialogClose() {
                this.xiaoguanShow = true;
            },
            onHuashuSelectDialogClose() {
                this.xiaoguanShow = true;
            },
            productItemClick(idx) {
                if (this.xkSelProductIdx === idx) {
                    this.xkSelProductIdx = -1;
                    this.xkSelProduct = "";
                } else {
                    this.xkSelProductIdx = idx;
                    this.xkSelProduct = this.productList[idx].name;
                }
                this.showProductDialog = false;
                this.xiaoguanShow = true;
            },
            addProduct() {
                this.showProductAddInput = true;
                this.$nextTick(() => {
                    const input = document.querySelector('.xkProductAddInputP .xkInput');
                    if (input) input.focus();
                });
            },
            confirmAddProduct() {
                if (this.newProductName.trim()) {
                    this.productList.push({
                        pid: Date.now(),
                        name: this.newProductName.trim(),
                        introduction: "",
                    });
                    this.newProductName = "";
                    this.showProductAddInput = false;
                }
            },
            xkTeamItemClick(idx) {
                if (this.xkSelTeamIdx === idx) {
                    this.xkSelTeamIdx = -1;
                } else {
                    this.xkSelTeamIdx = idx;
                }
                this.showHuashuSelectDialog = false;
                this.xiaoguanShow = true;
            },
            go2ImageList(item) {
                console.log("go2ImageList....");
                //关闭悬浮窗
                this.huashuItemMouseleave();

                //注意：这里必须直接使用列表渲染出来的 item，
                //不能再拿 showHuashuList 的下标去 huashuList 里取（置顶栏收起/搜索时两个数组并不一致，
                //会取到另一条话术，导致图片列表为空）
                if (!item) {
                    return;
                }
                localStorage.setItem("huashuData", JSON.stringify(item))
                this.$router.push({
                    path: '/imageList',
                    query: {
                        id: item.id
                    }
                })
            },
            huashuClick(idx) {
                this.typeSelIdx = idx;
                this.labelId = this.typeList[idx].labelId;
                this.huashuListLoadend = false;
                this.huashuPage = 1;
                this.huashuList = [];
                this.fetchHuashuList();
            },
            wenanCategoryClick(idx) {
                this.themeCategorySelIdx = idx;
                this.wenanLabelId = this.themeCategoryList[idx].labelId;
                this.wenanListLoadend = false;
                this.wenanPage = 1;
                this.wenanList = [];
                this.fetchWenanList();
            },
            // 图片元素转base64
            getBase64Image(img) {
                let canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                let ctx = canvas.getContext('2d');
                ctx?.drawImage(img, 0, 0, img.width, img.height);
                let dataURL = canvas.toDataURL('image/png');
                return dataURL;
            },
            // 图片元素转base64
            getBase64(img) {
                let canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                let ctx = canvas.getContext('2d');
                ctx?.drawImage(img, 0, 0, img.width, img.height);
                let dataURL = canvas.toDataURL('image/png');
                return dataURL;
            },
            // base64图片转为blob
            getBlobImage(dataurl) {
                let arr = dataurl.split(',');
                let mime = arr[0].match(/:(.*?);/)[1];
                let bstr = atob(arr[1]);
                let n = bstr.length;
                let u8arr = new Uint8Array(n);
                while (n--) {
                  u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], { type: mime });
            },
            // 复制图片
            async copyImage(imageUrl) {
                return new Promise(async (resolve,reject)=>{
                    // let dataurl = this.getBase64Image(dom);
                    // let blob = this.getBlobImage(dataurl);
                    // const blob = await fetch(imageUrl).then(r => r.blob());


                    fetch(imageUrl)
                    .then((response) => {
                        if (response.ok) {
                        return response.blob();
                        }
                    })
                    .then((blob) => {
                        return new Promise((resolve, reject) => {
                        let img = document.createElement('img');
                        img.onload = () => {
                            let canvas = document.createElement('canvas');
                            let ctx = canvas.getContext('2d');
                            canvas.width = img.width;
                            canvas.height = img.height;
                            ctx.drawImage(img, 0, 0, img.width, img.height);
                            canvas.toBlob(resolve, 'image/png');
                        };
                        img.onerror = reject;
                        img.src = URL.createObjectURL(blob);
                        });
                    })
                    .then((pngBlob) => {
                        let data = [new window.ClipboardItem({ [pngBlob.type]: pngBlob })];
                        navigator.clipboard.write(data);
                        resolve();
                    })
                    .then(() => {
                        console.log('Image copied to clipboard successfully');
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                    });


                    // navigator.clipboard.write([
                    // new window.ClipboardItem({
                    //     [blob.type]: blob
                    // })
                    // ]).then(()=>{
                    //     console.log("图片复制成功");
                    //     resolve();
                    // }, (err)=> {
                    //     console.log('图片复制失败！ err:',err);
                    //     resolve();
                    // });
                })
            },
            //去除字符串中的html标签
            stripHtmlTags(html) {
                // 将换行符占位符临时替换为特殊标记
                const withPlaceholders = html.replace(/\\n/g, '___NEWLINE___');
                
                // 去除HTML标签
                const withoutTags = withPlaceholders.replace(/<[^>]*>/g, '');
                
                // 将特殊标记恢复为换行符
                return withoutTags.replace(/___NEWLINE___/g, '\n');
            },
            itemClick(idx,isDbl=false) {
                //隐藏提示窗
                this.huashuItemMouseleave();

                let item = this.showHuashuList[idx]
                let text=this.stripHtmlTags(item.allText);
                if(item.isCarryTitle){
                    text=item.title+'\n'+text
                }else if(!text.trim().length){
                    // this.$message({
                    //     message: '话术无内容',
                    //     type: 'warning'
                    // });
                    return;
                }

                if(this.itemClickTimer){
                    clearTimeout(this.itemClickTimer)
                    this.itemClickTimer=null;
                }
                this.itemClickTimer=setTimeout(async ()=>{
                    navigator.clipboard.writeText(text).then(() => {
                        this.$message({
                            message: '文本已复制',
                            type: 'success'
                        });
                        console.log("item.text==", item.allText);
                        const {
                            ipcRenderer
                        } = window.require('electron');
                        // this.autoPartSend(item);
                        // let tmpEleIdx = 0;
                        // let autoTimer = setInterval(async ()=>{
                        //     if(tmpEleIdx>=item.eleList.length){
                        //         clearInterval(autoTimer)
                        //         autoTimer=null;
                        //         return;
                        //     }
                        //     if(item.eleList[tmpEleIdx].type=='text'){
                        //         ipcRenderer.send('type-text', item.eleList[tmpEleIdx].val,isDbl);
                        //     }else{
                        //         await this.copyImage(item.eleList[tmpEleIdx].val);
                        //         ipcRenderer.send('type-img');
                        //     }
                            
                        //     tmpEleIdx++;
                        // },1000)
                        ipcRenderer.send('type-text', text,isDbl);
                    }, function () {
                        console.log('文件复制失败！');
                    });
                },300)
            },
            wenanItemClick(idx,isDbl=false) {
                if(this.itemClickTimer){
                    clearTimeout(this.itemClickTimer)
                    this.itemClickTimer=null;
                }
                this.itemClickTimer=setTimeout(()=>{
                    let item = this.wenanList[idx]
                    navigator.clipboard.writeText(item.text).then(() => {
                        // if(this.tools.isElectron){
                        this.$message({
                            message: '文本已复制',
                            type: 'success'
                        });
                        console.log("item.text==", item.text);
                        const {
                            ipcRenderer
                        } = window.require('electron');
                        ipcRenderer.send('type-text', item.text,isDbl);
                        // }
                    }, function () {
                        console.log('文件复制失败！');
                    });
                },300)
            },
            async fetchData() {
                // ── 启动加载容错 ──
                // 原来请求失败是完全静默的（列表全空、无提示、无重试）：开机自启时网络/DNS
                // 还没就绪命中一次，用户看到的就是"刚打开软件所有接口的数据都没出现，
                // 关掉重开就好了"。这里：失败自动重试一次，仍然失败才给出可见提示。
                this._lastRequestFailed = false;
                if (this.tabIndex == 0) {
                    await this.fetchHuashuTeamList();
                } else if (this.tabIndex == 1) {
                    await this.fetchDefaultWenanPackageList()
                    this.fetchWenanPackageList();
                }
                if (!this._lastRequestFailed) {
                    this._dataLoadRetryCount = 0;
                    return;
                }
                if ((this._dataLoadRetryCount || 0) >= 1) {
                    this.$message({
                        message: "数据加载失败，请检查网络后重试",
                        type: 'error'
                    });
                    return;
                }
                this._dataLoadRetryCount = (this._dataLoadRetryCount || 0) + 1;
                console.log("[fetchData] 首次加载失败，1.5 秒后自动重试一次");
                clearTimeout(this._dataLoadRetryTimer);
                this._dataLoadRetryTimer = setTimeout(() => {
                    this.fetchData();
                }, 1500);
            },
            //查询话术变量列表
            fetchHuashuValList() {
                return this.ensureSettled(async (resolve,reject)=>{
                    let params = {
                        speechId:this.speechId,
                    }
                    console.log("fetchHuashuValList params=", params);
                    let resp = await this.$http.fetchHuashuValList(params)
                    if (resp.code == 200) {
                        this.huashuValList = resp.data.array || [];
                        //编辑话术窗口是通过 localStorage 读取变量列表的
                        localStorage.setItem("huashuValList", JSON.stringify(this.huashuValList));
                        //变量列表更新后，重新渲染已经加载的话术
                        this.refreshHuashuItemText();
                    }
                    resolve();
                })
            },
            //查询默认文案包列表
            async fetchDefaultWenanPackageList() {
                return this.ensureSettled(async (resolve, reject) => {
                    let params = {}
                    console.log("wenanPackageList params=", params);
                    let resp = await this.$http.defaultWenanPackageList(params)
                    if (resp.code == 200) {
                        this.defaultThemeList = [resp.data.object];
                    }
                    resolve();
                })
            },
            //查询文案包列表
            async fetchWenanPackageList() {
                let params = {
                    page: this.themePage,
                    pageSize: this.themePageSize,
                    type: 1,
                }
                console.log("wenanPackageList params=", params);
                let resp = await this.$http.wenanPackageList(params)
                console.log("wenanPackageList resp:", resp)
                if (resp.code === 200) {
                    if (this.themePage == 1 && resp.data.array && !resp.data.array.length) {
                        // this.themeList.splice(this.themeList.length,0,resp.data.array)
                        this.themeList = this.defaultThemeList;
                    } else if (resp.data.array && resp.data.array.length) {
                        this.themeList = resp.data.array;
                    }

                    if (localStorage.getItem("lastSelThemeId")) {
                        this.themeId = localStorage.getItem("lastSelThemeId");
                        this.themeList.forEach((theme, idx) => {
                            if (this.themeId == theme.themeId) {
                                this.themeSelIdx = idx;
                            }
                        })
                    } else {
                        this.themeId = this.themeList[0].themeId;
                    }
                    // else if(!this.themeList.length&&resp.data.array.length){
                    //     this.themeId=this.themeList[0].themeId;
                    // }
                    // this.themeList=resp.data.array;
                    if (this.themeList && this.themeList.length) {
                        this.fetchWenanPackageCategoryList();
                    }
                    // else{
                    //     this.$msgbox({
                    //         message: '暂无文案包，请到微脉输入法App文案广场添加',
                    //         type: 'info'
                    //     }).then(() => {
                    //         this.tabClick(0)
                    //     });
                    // }
                } else {
                    this.$message({
                        message: resp.message,
                        type: 'warning'
                    });
                }
            },
            //查询文案包分类列表
            async fetchWenanPackageCategoryList() {
                this.themeCategoryLoading = true;
                let params = {
                    page: this.themeCategoryPage,
                    pageSize: this.themeCategoryPageSize,
                    themeId: this.themeId,
                }
                console.log("wenanCategoryList params=", params);
                let resp = await this.$http.wenanCategoryList(params)
                console.log("wenanCategoryList resp:", resp)
                if (resp.code === 200) {
                    if (resp.data.array.length < this.themeCategoryPageSize) {
                        this.themeCategoryLoadend = true;
                    }
                    if (resp.data.array.length) {
                        this.themeCategoryList.splice(this.themeCategoryList.length, 0, ...resp.data.array);
                    }
                    if (this.themeCategoryList.length && this.themeCategoryPage == 1) {
                        this.wenanLabelId = this.themeCategoryList[0].labelId;
                        this.fetchWenanList();
                    }
                    this.themeCategoryPage++;
                } else {
                    this.$message({
                        message: resp.message,
                        type: 'warning'
                    });
                }
                this.themeCategoryLoading = false;
            },
            //查询文案列表
            async fetchWenanList() {
                this.wenanloading = true;
                let params = {
                    page: this.wenanPage,
                    pageSize: this.wenanPageSize,
                    themeId: this.themeId,
                    labelId: this.wenanLabelId,
                }
                console.log("wenanList params=", params);
                let resp = await this.$http.wenanList(params)
                console.log("wenanList resp:", resp)
                if (resp.code === 200) {
                    if (resp.data.array.length < this.wenanPageSize) {
                        this.wenanListLoadend = true;
                    }
                    if (resp.data.array.length) {
                        // resp.data.array=resp.data.array.map((val)=>{
                        //     val.eleList=this.generateEleList(val.speechText);
                        //     val.imglist=val.eleList.filter((eleListItem)=>{
                        //         eleListItem.val=eleListItem.val.replace("http://","https://")
                        //          return eleListItem.type=='img'||eleListItem.type=='video'
                        //     })
                        //     val.filelist=val.eleList.filter((eleListItem)=>{
                        //         eleListItem.val=eleListItem.val.replace("http://","https://")
                        //          return eleListItem.type=='file'||eleListItem.type=='audio'
                        //     })
                        //     val.allText=this.getEleListAllText(val.eleList);
                        //     return val;
                        // })
                        this.wenanList.splice(this.wenanList.length, 0, ...resp.data.array);
                    }
                    if (this.wenanList.length && this.wenanPage == 1) {
                        this.wenanId = this.wenanList[0].libraryId;
                    }
                    this.wenanPage++;
                } else {
                    this.$message({
                        message: resp.message,
                        type: 'warning'
                    });
                }
                this.updateCellStyle();
                this.wenanloading = false;
            },
            async fetchHuashuTeamList() {
                return this.ensureSettled(async (resolve,reject)=>{
                    let params = {}
                    console.log("fetchHuashuTeamList params=", params);
                    let resp = await this.$http.qryHuashuTeamList(params)
                    console.log("fetchHuashuTeamList resp:", resp)
                    if (resp.code === 200) {
                        if(!resp.data.array.length){
                            this.$message({
                                message: "未检测到话术团队，请在app端加入团队再使用",
                                type: 'error'
                            });
                            return
                        }
                        if (localStorage.getItem("lastSelSpeechId")) {
                            this.speechId = localStorage.getItem("lastSelSpeechId");
                            resp.data.array.forEach((team, idx) => {
                                if (this.speechId == team.speechId) {
                                    this.teamSelIdx = idx;
                                }
                            })
                        } else if (!this.huashuTeamList.length && resp.data.array.length) {
                            this.speechId = resp.data.array[0].speechId;
                        }

                        this.huashuTeamList = resp.data.array;
                        if (resp.data.array && resp.data.array.length) {
                            await this.fetchHuashuTeamDetail()
                            await this.fetchHuashuValList();
                            await this.fetchHuashuTypeList();
                        }
                    } else {
                        this.$message({
                            message: resp.message,
                            type: 'warning'
                        });
                    }
                    resolve();
                })
            },
            async fetchHuashuTeamDetail() {
                return this.ensureSettled(async (resolve, reject) => {
                    this.hushuTypeLoading = true;
                    let params = {
                    speechId: this.speechId,
                    };
                    console.log("fetchHuashuTeamDetail params=", params);
                    let resp = await this.$http.fetchHuashuTeamDetail(params);
                    console.log("fetchHuashuTeamDetail resp:", resp);
                    if (resp.code === 200) {
                    this.currentHuashuTeamInfo = resp.data.object;
                    } else {
                    this.$message({
                        message: resp.message,
                        type: "warning",
                    });
                    }
                    resolve();
                });
            },
            async fetchHuashuTypeList() {
                return this.ensureSettled(async (resolve,reject)=>{
                    this.hushuTypeLoading = true;
                    let params = {
                        page: this.typePage,
                        pageSize: this.typePageSize,
                        speechId: this.speechId,
                    }
                    console.log("qryHuashuTypeList params=", params);
                    let resp = await this.$http.qryHuashuTypeList(params)
                    console.log("qryHuashuTypeList resp:", resp)
                    if (resp.code === 200) {

                        if (this.currentHuashuTeamInfo&&this.currentHuashuTeamInfo.hideLabelIds&&
            this.currentHuashuTeamInfo.roleId != 2) {
                            let hideLabelIds = JSON.parse(
                                this.currentHuashuTeamInfo.hideLabelIds
                            );
                            hideLabelIds.forEach((hideTypeItem) => {
                                resp.data.array.forEach((typeIteam) => {
                                    if (typeIteam.labelId == hideTypeItem) {
                                        typeIteam.hide = true;
                                    }
                                });
                            });
                            resp.data.array = resp.data.array.filter((typeIteam) => {
                                return !typeIteam.hide;
                            });
                        }

                        
                        if (resp.data.array.length < this.typePageSize) {
                            this.typeListLoadend = true;
                        }
                        if (resp.data.array.length) {
                            this.typeList.splice(this.typeList.length, 0, ...resp.data.array);
                        }
                        if (this.typeList.length && this.typePage == 1) {
                            this.labelId = this.typeList[0].labelId;
                            await this.fetchHuashuList();
                        }
                        this.typePage++;
                    } else {
                        this.$message({
                            message: resp.message,
                            type: 'warning'
                        });
                    }
                    this.hushuTypeLoading = false;
                    resolve();
                })
            },
            async fetchHuashuList() {
                return this.ensureSettled(async (resolve,reject)=>{
                    this.loading = true;
                    let params = {
                        page: this.huashuPage,
                        pageSize: this.huashuPageSize,
                        speechId: this.speechId,
                        labelId: this.labelId,
                    }
                    console.log("qryHuashuList params=", params);
                    let resp = await this.$http.qryHuashuList(params)
                    console.log("qryHuashuList resp:", resp)
                    if (resp.code === 200) {
                        if (resp.data.array.length < this.huashuPageSize) {
                            this.huashuListLoadend = true;
                        }
                        if (resp.data.array.length) {
                            resp.data.array = resp.data.array.map((val) => {
                                return this.decorateHuashuItem(val);
                            })
                            this.huashuList.splice(this.huashuList.length, 0, ...resp.data.array);
                            this.countTopHuashu = this.huashuList.filter((val) => {
                                return val.isTop
                            }).length;
                            if (this.huashuTopBarShow) {
                                this.showHuashuList = this.huashuList;
                            } else {
                                this.showHuashuList = this.huashuList.filter((huashu) => {
                                    return !huashu.isTop
                                });
                            }
                        }
                        if (this.huashuList.length && this.huashuPage == 1) {
                            this.huashuDetailId = this.huashuList[0].id;
                        }
                        this.huashuPage++;
                    } else {
                        this.$message({
                            message: resp.message,
                            type: 'warning'
                        });
                    }
                    this.updateCellStyle();
                    this.loading = false;
                    resolve();
                })
            },
            convertColorTags(html) {
                // 使用正则全局替换所有匹配的标签
                return html.replace(
                    /<标记颜色开始(#(?:[\da-fA-F]{3}){1,2})>([\s\S]*?)<\/标记颜色结束>/gi,
                    (match, colorCode, content) => {
                    return `<span style="color: ${colorCode}">${content}</span>`;
                    }
                );
            },
            updateCellStyle() {
                setTimeout(() => {
                    let list = []
                    if (this.tabIndex == 0) {
                        list = JSON.parse(JSON.stringify(this.showHuashuList))
                    } else {
                        list = JSON.parse(JSON.stringify(this.wenanList))
                    }
                    list.forEach((item) => {
                        let id = this.tabIndex == 0 ? item.id : item.libraryId;
                        if (this.$refs[id]) {
                            let ele = this.$refs[id][0];
                            let showEle = this.$refs['show' + id][0];
                            let shouqiHeight = this.wenanShowLineCount * 20 - 1;
                            if (ele.clientHeight > shouqiHeight && ele.clientHeight > showEle
                                .clientHeight) {
                                item.showBtn = 'zhankai';
                            } else {
                                item.showBtn = '';
                            }
                            // console.log("ele:",ele);
                        }
                    })
                    if (this.tabIndex == 0) {
                        this.showHuashuList = list;
                    } else {
                        this.wenanList = list;
                    }
                }, 1)
            },
            replaceAll(string, search, replace) {
                if (string === undefined || string === null) {
                    return "";
                }
                //join(undefined)会默认用","拼接，必须兜底
                if (replace === undefined || replace === null) {
                    replace = "";
                }
                return string.split(search).join(replace);
            },
            generateEleList(speechText) {
                let eleList = []
                let _this = this;
                let text = speechText;
                // text = this.replaceAll(text, "<分段>\n", "");
                // text = this.replaceAll(text, "<分段>", "\n");
                text = this.replaceAll(text, "\n<连行开始>", "");
                text = this.replaceAll(text, "</连行结束>\n", "");
                text = this.replaceAll(text, "<连行开始>", "");
                text = this.replaceAll(text, "</连行结束>", "");
                // text = this.replaceAll(text, "\n", "\n\n");
                text=text.replace(/<\/?标记颜色开始#[0-9a-fA-F]{6}>/g, '');

                const urlRegex =
                    /https?:\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]\.(png|jpg|jpeg|pdf|docx|doc|dotm|xlsx|xls|mp4|mov|mp3|m4a|aac|caf|pptx|ppt|txt)/gi;
                const urls = [];
                let match;
                let lastPart = text;

                while ((match = urlRegex.exec(text)) !== null) {
                    let url = match[0];
                    const fileExtension = this.getFileExtension(url);

                    // 只添加具有正确文件后缀的URL
                    if (fileExtension === 'png' || fileExtension === 'jpg' || fileExtension === 'jpeg' ||
                        fileExtension === 'pdf' || fileExtension === 'doc' || fileExtension === 'docx' ||
                        fileExtension === 'dotm' || fileExtension === 'dotx' || fileExtension === 'dotm' ||
                        fileExtension === 'txt' || fileExtension === 'xlsx' || fileExtension === 'xls' ||
                        fileExtension === 'mp4' || fileExtension === 'mov' || fileExtension === 'mp3' ||
                        fileExtension === 'm4a' || fileExtension === 'aac' || fileExtension === 'caf' ||
                        fileExtension === 'ppt' || fileExtension === 'pptx') {
                        let tmp = lastPart.split(url);
                        // console.log("tmp==",tmp[0]);
                        eleList.push({
                            type: "text",
                            val: tmp[0],
                        })
                        if (fileExtension === 'jpg' || fileExtension === 'png' || fileExtension === 'jpeg') {
                            eleList.push({
                                type: "img",
                                val: url,
                            })
                            // this.imgUrlList.push(url)
                        } else if (fileExtension === 'mp4') {
                            eleList.push({
                                type: "video",
                                val: url,
                            })
                        } else if (fileExtension === 'mp3' || fileExtension === 'm4a') {
                            let eleIdx = eleList.length;
                            let tmpUrl = new URL(url);
                            let fileName = tmpUrl.pathname.split('/').pop();
                            let audio = new Audio();
                            audio.src = url;
                            audio.id = "audio" + eleIdx;
                            let id = new Date().getTime();
                            eleList.push({
                                type: "audio",
                                val: url,
                                fileName: fileName,
                                fileIcon: this.getFileIcon(fileName),
                                id: id
                            })
                        } else {
                            let tmpUrl = new URL(url);
                            const fileName = tmpUrl.pathname.split('/').pop();
                            eleList.push({
                                type: "file",
                                val: url,
                                fileName: fileName,
                                fileIcon: this.getFileIcon(fileName)
                            })
                        }
                        // lastPart=tmp[1]
                        let str = ""
                        tmp.forEach((tmpItem, idx) => {
                            if (idx) {
                                str += tmpItem
                            }
                        })
                        lastPart = str;
                    }
                }
                eleList.push({
                    type: "text",
                    val: lastPart,
                })
                return eleList
            },
            getEleListAllText(eleList) {
                let text = "";
                eleList.forEach((ele,idx) => {
                    if (ele.type == "text") {
                        // 处理文本元素
                        // if(idx>0&&eleList[idx-1].type!="text"&&ele.val.substr(0,1)=='\n'){
                        //     ele.val = ele.val.substr(1)
                        // }
                        let tmp = this.replaceAll(ele.val, "<分段>\n", "");
                        tmp = this.replaceAll(tmp, "<分段>", "\n");
                        text += tmp;
                    }
                })
                return text;
            },
            // 提取文件后缀的辅助函数
            getFileExtension(url) {
                const path = url.split('/');
                const fileName = path[path.length - 1];
                const parts = fileName.split('.');

                if (parts.length > 1) {
                    return parts.pop();
                }

                return '';
            },
            getVideoDuration(url) {
                let video = document.createElement('video');
                video.src = url;
                video.load();
                video.onload = () => {
                    console.log("video==", video);
                }
            },
            getFileIcon(fileName) {
                let icon = ""
                if (fileName.includes(".doc")) {
                    icon = "https://imagessl.edujia.com/A-1ed71af7_20230602143256.png"
                } else if (fileName.includes(".txt")) {
                    icon = "https://imagessl.edujia.com/A-1ed71af7_20230602143245.png"
                } else if (fileName.includes(".xls")) {
                    icon = "https://imagessl.edujia.com/A-1ed71af7_20230602143214.png"
                } else if (fileName.includes(".mp3") || fileName.includes(".m4a")) {
                    icon = "https://imagessl.edujia.com/A-1ed71af7_20230529114041.png"
                } else if (fileName.includes(".pdf")) {
                    icon = "https://imagessl.edujia.com/A-1ed71af7_20230529114100.png"
                } else if (fileName.includes(".ppt") || fileName.includes(".pptx")) {
                    icon = "https://imagessl.edujia.com/A-1ed71af7_20230608114321.png"
                } else {
                    icon = "https://imagessl.edujia.com/A-1ed71af7_20230601152642.png"
                }
                return icon;
            },
            //滚轮左右滑动
            wheelHScroll(event){
                event.preventDefault();
                // 根据滚轮的垂直滚动值设置水平滚动
                event.currentTarget.scrollLeft += event.deltaY;
            },
            // bottomBarP 仅在 tabIndex==0 时渲染，回到首页 Tab 后再绑定滚轮横向滚动
            attachBottomBarWheel(){
                if (this.tabIndex !== 0) return;
                this.$nextTick(() => {
                    if (this.$refs.bottomBarP) {
                        this.$refs.bottomBarP.addEventListener('wheel', this.wheelHScroll);
                    }
                });
            },
            openSortDialog(){
                this.sortTypeList = JSON.parse(JSON.stringify(this.typeList));
                this.sortDialogVisible = true;
            },
            closeSortDialog(){
                this.sortDialogVisible = false;
                this.sortTypeList = [];
                this.dragIndex = -1;
                this.dragOverIndex = -1;
            },
            onSortDragStart(index){
                this.dragIndex = index;
            },
            onSortDragOver(index){
                this.dragOverIndex = index;
            },
            onSortDrop(index){
                if (this.dragIndex === index || this.dragIndex < 0) return;
                const list = this.sortTypeList;
                const item = list[this.dragIndex];
                const newList = list.filter((_, i) => i !== this.dragIndex);
                newList.splice(index, 0, item);
                this.sortTypeList = newList;
                this.dragIndex = -1;
                this.dragOverIndex = -1;
            },
            onSortDragEnd(){
                this.dragIndex = -1;
                this.dragOverIndex = -1;
            },
            async saveSortOrder(){
                const orderChanged = this.sortTypeList.some((item, index) => item.labelId !== this.typeList[index].labelId);
                if (!orderChanged) {
                    this.closeSortDialog();
                    return;
                }
                const resp = await this.$http.sortHushuType({
                    speechId: this.speechId,
                    labelIdArray: this.sortTypeList.map((item, index) => item.labelId)
                });
                if (resp.code == 200) {
                    this.typeList = JSON.parse(JSON.stringify(this.sortTypeList));
                    this.closeSortDialog();
                } else {
                    this.$message({ message: resp.message, type: 'warning' });
                }
            },
            // ── 备忘提醒横幅 ──
            startMemoRemindWatcher() {
                if (!(this.$common.isElectron() && window.require)) {
                    return;
                }
                this.stopMemoRemindWatcher();
                const {
                    ipcRenderer
                } = window.require('electron');
                //横幅点击 → 主窗口切到备忘Tab
                this._memoRemindClickHandler = () => {
                    this.tabClick(2);
                };
                ipcRenderer.on('memoReminderClick', this._memoRemindClickHandler);
                //备忘保存/修改后重新调度提醒
                this._memoSavedHandler = () => {
                    this.scheduleMemoReminders();
                };
                ipcRenderer.on('memoSaved', this._memoSavedHandler);
                //备忘列表刷新时（打开Tab/保存/编辑后）更新缓存并重新调度，不额外轮询服务端
                this._memoListUpdatedHandler = () => {
                    this.scheduleMemoReminders();
                };
                window.addEventListener("memoListUpdated", this._memoListUpdatedHandler);
                //启动后拉取一次备忘列表作为调度数据（silent，失败不打扰）
                setTimeout(() => {
                    this.fetchMemoRemindersList().then((array) => {
                        setMemoListCache(array);
                        this.scheduleMemoReminders();
                    });
                }, 3000);
            },
            stopMemoRemindWatcher() {
                if (this.memoRemindFireTimer) {
                    clearTimeout(this.memoRemindFireTimer);
                    this.memoRemindFireTimer = null;
                }
                this.memoBannerClose();
                if (this._memoRemindClickHandler && window.require) {
                    try {
                        window.require('electron').ipcRenderer.removeListener('memoReminderClick',
                            this._memoRemindClickHandler);
                    } catch (e) {}
                }
                this._memoRemindClickHandler = null;
                if (this._memoSavedHandler && window.require) {
                    try {
                        window.require('electron').ipcRenderer.removeListener('memoSaved', this
                            ._memoSavedHandler);
                    } catch (e) {}
                }
                this._memoSavedHandler = null;
                if (this._memoListUpdatedHandler) {
                    window.removeEventListener("memoListUpdated", this._memoListUpdatedHandler);
                }
                this._memoListUpdatedHandler = null;
            },
            //启动时拉取一次备忘列表（silent：失败不弹错误提示）
            fetchMemoRemindersList() {
                return this.$http.memoQueryList({}, {
                    silent: true
                }).then((resp) => {
                    if (resp && resp.code == 200) {
                        return (resp.data && resp.data.array) || [];
                    }
                    return [];
                }).catch(() => {
                    return [];
                });
            },
            //精确调度：基于「列表刷新时的缓存数据」找到最近一条到期时间，到点第一秒触发
            scheduleMemoReminders() {
                if (!(this.$common.isElectron() && window.require)) {
                    return;
                }
                const array = getMemoListCache();
                const now = Date.now();
                let nearest = null;
                array.forEach((item) => {
                    const t = nextOccurrence(item, now);
                    if (t && t.getTime() > now) {
                        if (!nearest || t.getTime() < nearest) {
                            nearest = t.getTime();
                        }
                    }
                });
                if (this.memoRemindFireTimer) {
                    clearTimeout(this.memoRemindFireTimer);
                    this.memoRemindFireTimer = null;
                }
                let delay = 60 * 60 * 1000; //无提醒时每小时重新校准一次
                if (nearest) {
                    //到点后+500ms触发，最多1小时后重新校准（防止定时器漂移）
                    delay = Math.min(nearest - now + 500, 60 * 60 * 1000);
                }
                this.memoRemindFireTimer = setTimeout(() => {
                    this.memoRemindFireTimer = null;
                    this.fireMemoRemindersAt(nearest);
                }, delay);
            },
            //精确到点触发：基于缓存数据判定（睡眠唤醒等允许10分钟内补触发）
            fireMemoRemindersAt(atTime) {
                const now = Date.now();
                if (atTime && (now < atTime || now - atTime > 10 * 60 * 1000)) {
                    //时间漂移过大（如休眠超过10分钟）：直接重新调度，不补发
                    this.scheduleMemoReminders();
                    return;
                }
                const array = getMemoListCache();
                const fired = this.getReminderFiredMap();
                const {
                    ipcRenderer
                } = window.require('electron');
                array.forEach((item) => {
                    if (isReminderDue(item, now, 10 * 60 * 1000)) {
                        const key = reminderFireKey(item, now);
                        if (fired[key]) {
                            return;
                        }
                        fired[key] = 1;
                        //App内顶部横幅（系统通知可能被忽略）
                        this.showMemoReminderBanner(item);
                        //同时弹系统通知
                        ipcRenderer.send('memoReminderShow', JSON.stringify({
                            id: item.id,
                            content: item.content || "",
                            remindText: formatRemind(item),
                        }));
                    }
                });
                this.saveReminderFiredMap(fired);
                //继续调度下一次
                this.scheduleMemoReminders();
            },
            getReminderFiredMap() {
                try {
                    const raw = localStorage.getItem("wminput:memo:reminderFired");
                    return raw ? JSON.parse(raw) : {};
                } catch (e) {
                    return {};
                }
            },
            saveReminderFiredMap(map) {
                try {
                    //只保留最近500条，防止无限膨胀
                    const keys = Object.keys(map);
                    if (keys.length > 500) {
                        keys.slice(0, keys.length - 500).forEach((k) => {
                            delete map[k];
                        });
                    }
                    localStorage.setItem("wminput:memo:reminderFired", JSON.stringify(map));
                } catch (e) {}
            },
            //展示App内备忘提醒横幅（不自动消失，需用户点击关闭）
            showMemoReminderBanner(item) {
                this.memoReminderBanner = {
                    id: item.id,
                    content: item.content || "",
                    remindText: formatRemind(item),
                };
            },
            memoBannerClose() {
                this.memoReminderBanner = null;
                // 横幅关闭后通知主进程恢复主窗口原有置顶层级（尊重「取消置顶」设置）
                if (this.$common.isElectron() && window.require) {
                    try {
                        window.require('electron').ipcRenderer.send('memoReminderDismiss');
                    } catch (e) {}
                }
            },
            memoBannerClick() {
                this.memoBannerClose();
                this.tabClick(2);
            },
            //同步窗口尺寸（pageWidth/pageHeight）
            onWindowResize() {
                this.pageWidth = window.innerWidth || document.documentElement.clientWidth || document.body
                    .clientWidth;
                this.pageHeight = window.innerHeight || document.documentElement.clientHeight || document.body
                    .clientHeight;
            },
        },
        async created() {
            console.log("created...");
            this.loadTopTabOrder();
            this.restoreActiveTabState();
            //窗口高度变化必须第一时间同步：先挂 resize 监听，再去做本地数据版本迁移/初始化。
            //否则（版本迁移提前 return、或 initDb 抛错时）监听挂不上，pageHeight 会一直停在旧值，
            //窗口变矮后内容区仍按旧高度渲染，整页就会出现滚动条。
            window.addEventListener('resize', this.onWindowResize);
            if(localStorage.getItem("localDataVersion")!=this.$config.localDataVersion){
                localStorage.setItem("localDataVersion",this.$config.localDataVersion)
                // localStorage.clear();
                localStorage.removeItem("syncParamsList")
                await dbService.clearAllData();
                return;
            }


            await dbService.initDb();
            this.localHuashuListData = await dbService.getAllData("huashuList")
            if (localStorage.getItem("huashuTopBarHide")) {
                this.huashuTopBarShow = false;
            }
            // if (localStorage.getItem("wenanShowLineCount")) {
            //     this.wenanShowLineCount = parseInt(localStorage.getItem("wenanShowLineCount"));
            // }
            this.faceIcon = localStorage.getItem("edujia:group:web:faceIcon")
            if (localStorage.getItem("edujia:group:web:token")) {
                this.$store.commit('modifyToken', localStorage.getItem("edujia:group:web:token"))
            }
            if (localStorage.getItem('typeListWidth')) {
                this.typeListWidth = localStorage.getItem('typeListWidth')
            }
        },
        mounted() {
            console.log("mounted...");
            this.homeMounted = true;
            if(window.require){
                const { ipcRenderer } = window.require('electron');
                ipcRenderer.send('getSettingInfo');
                let _this=this;
                ipcRenderer.on('webLog', (event, logStr) => {
                    this.$message('logStr:'+logStr);
                })
                ipcRenderer.on('getSettingInfoResp', (event, settingInfoStr) => {
                    if(settingInfoStr){
                        _this.$store.commit('modifySettingInfo',JSON.parse(settingInfoStr));
                    }
                })
                ipcRenderer.on('updateHuashuItem', (event, huashuItem) => {
                    console.log("updateHuashuItem:",huashuItem)
                    _this.decorateHuashuItem(huashuItem);
                    let resultIdx = -1;
                    _this.huashuList.forEach((val, idx) => {
                        if (huashuItem.id == val.id) {
                            resultIdx = idx;
                        }
                    })
                    if (resultIdx != -1) {
                        huashuItem.isTop=_this.huashuList[resultIdx].isTop;
                        _this.huashuList.splice(resultIdx, 1, huashuItem)
                    } else if (huashuItem.isTop == 1&&huashuItem.isFront == 1) {
                        _this.huashuList.splice(0, 0, huashuItem)    
                    } else if(huashuItem.isTop == 1&&huashuItem.isFront == 2){
                        _this.huashuList.splice(_this.countTopHuashu, 0, huashuItem)
                    }else if(huashuItem.isFront == 1){
                        _this.huashuList.splice(_this.countTopHuashu, 0, huashuItem)
                    }else {
                        _this.huashuList.splice(_this.huashuList.length, 0, huashuItem)
                    }
                    // if(this.huashuListLoadend){
                    //     this.huashuList.splice(this.huashuList.length,0,huashuItem)
                    // }
                    _this.updateCellStyle();
                })
                
            }
            if (this.$refs.topSubP) this.$refs.topSubP.addEventListener('wheel', this.wheelHScroll);
            this.attachBottomBarWheel();
            // 顶部 Tab 长按排序：document 级监听移动/抬起
            document.addEventListener('mousemove', this.onTopTabDocMove);
            document.addEventListener('mouseup', this.onTopTabDocUp);
            //备忘提醒横幅：到点检测
            this.startMemoRemindWatcher();
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.onWindowResize);
            this.stopMemoRemindWatcher();
            document.removeEventListener('mousemove', this.onTopTabDocMove);
            document.removeEventListener('mouseup', this.onTopTabDocUp);
            this.clearTopTabLongPress();
        },
        activated() {
            console.log("activated...");
            if (localStorage.getItem("needReresh")) {
                this.typePage = 1;
                this.typeListLoadend = false;
                this.typeList = [];
                localStorage.removeItem("needReresh");
            }
            this.fetchData();
            if (this.tabIndex == 2 && this.$refs.memoList) {
                this.$refs.memoList.refresh();
            }
            // if (localStorage.getItem("updateHuashuItem")) {
            //     let huashuItem = JSON.parse(localStorage.getItem("updateHuashuItem"))
            //     huashuItem.eleList = this.generateEleList(huashuItem.speechText);
            //     huashuItem.imglist = huashuItem.eleList.filter((eleListItem) => {
            //         eleListItem.val = eleListItem.val.replace("http://", "https://")
            //         return eleListItem.type == 'img' || eleListItem.type == 'video'
            //     })
            //     huashuItem.filelist = huashuItem.eleList.filter((eleListItem) => {
            //         eleListItem.val = eleListItem.val.replace("http://", "https://")
            //         return eleListItem.type == 'file' || eleListItem.type == 'audio'
            //     })
            //     huashuItem.allText = this.getEleListAllText(huashuItem.eleList);
            //     let resultIdx = -1;
            //     this.huashuList.forEach((val, idx) => {
            //         if (huashuItem.id == val.id) {
            //             resultIdx = idx;
            //         }
            //     })
            //     if (resultIdx != -1) {
            //         huashuItem.isTop=this.huashuList[resultIdx].isTop;
            //         this.huashuList.splice(resultIdx, 1, huashuItem)
            //     } else if (huashuItem.isFront == 1) {
            //         this.huashuList.splice(this.countTopHuashu, 0, huashuItem)
            //     } else {
            //         this.huashuList.splice(this.huashuList.length, 0, huashuItem)
            //     }
            //     // if(this.huashuListLoadend){
            //     //     this.huashuList.splice(this.huashuList.length,0,huashuItem)
            //     // }
            //     localStorage.removeItem("updateHuashuItem");
            //     this.updateCellStyle();
            // }
        },
    }
</script>

<style>
    .el-dialog__body {
        padding: 10px 20px;
    }

    /* 隐藏垂直滚动条 */
    /* ::-webkit-scrollbar {
        width: 0;
    } */
    
    /* 隐藏水平滚动条 */
    /* ::-webkit-scrollbar {
        height: 0;
    } */

    .el-message-box {
        display: inline-block;
        width: 80%;
        min-width: 200px;
        max-width: 300px;
        padding-bottom: 10px;
        vertical-align: middle;
        background-color: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #EBEEF5;
        font-size: 18px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        text-align: left;
        overflow: hidden;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
    }

    /* ::-webkit-scrollbar {
        width: 5px;
        height: 5px;
    }

    ::-webkit-scrollbar-button, ::-webkit-scrollbar-corner {
        background: none;
    }

    ::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: lightgray;
        transition: 0.3s ease-in-out;
    }

    ::-webkit-scrollbar-track {
        background: none;
    } */
</style>

<style scoped>
    /* 备忘提醒 App内顶部横幅（醒目样式） */
    .memoRemindBanner {
        position: fixed;
        left: 8px;
        right: 8px;
        top: 0;
        z-index: 99990;
        display: flex;
        align-items: center;
        background: linear-gradient(180deg, #FFEBEB 0%, #FFF2F2 100%);
        border: 1px solid #FFC1C1;
        border-left: 4px solid #FB5D5C;
        border-radius: 8px;
        padding: 12px 14px;
        box-shadow: 0 4px 16px rgba(251, 93, 92, 0.28);
        cursor: pointer;
        user-select: none;
        animation: memoBannerIn 0.25s ease-out,
            memoBannerShake 1.8s ease-in-out 0.4s infinite;
    }

    @keyframes memoBannerIn {
        from {
            transform: translateY(-100%);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }

    /* 闹铃式抖动：频率较高、幅度很小（±2px），未关闭前持续提醒 */
    @keyframes memoBannerShake {
        0%,
        8%,
        16%,
        24%,
        32%,
        40%,
        48%,
        100% {
            transform: translateX(0) rotate(0deg);
        }
        4% {
            transform: translateX(-2px) rotate(-0.25deg);
        }
        12% {
            transform: translateX(2px) rotate(0.25deg);
        }
        20% {
            transform: translateX(-2px) rotate(-0.25deg);
        }
        28% {
            transform: translateX(2px) rotate(0.25deg);
        }
        36% {
            transform: translateX(-1.5px) rotate(-0.2deg);
        }
        44% {
            transform: translateX(1.5px) rotate(0.2deg);
        }
    }

    .memoRemindBannerIcon {
        color: #FB5D5C;
        margin-right: 10px;
        flex-shrink: 0;
        width: 34px;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #fff;
        border-radius: 50%;
        box-shadow: 0 1px 4px rgba(251, 93, 92, 0.35);
    }

    .memoRemindBannerBody {
        flex: 1;
        min-width: 0;
    }

    .memoRemindBannerTitle {
        font-size: 13px;
        font-weight: bold;
        color: #FB5D5C;
        line-height: 18px;
    }

    .memoRemindBannerContent {
        font-size: 14px;
        color: #3C3C3C;
        line-height: 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .memoRemindBannerClose {
        flex-shrink: 0;
        width: 26px;
        height: 26px;
        margin-left: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #FB5D5C;
        font-size: 20px;
        border-radius: 50%;
        cursor: pointer;
        background: #FFE0E0;
    }

    .memoRemindBannerClose:hover {
        color: #fff;
        background-color: #FB5D5C;
    }

    .top {
        padding-bottom: 8px;
        /*    height: 32px;*/
        height: 74px;
        padding-top: 40px;
        box-shadow: 0 2px 4px 0 #e5e5e58a;
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
        min-width: 200px;
    }

    .topSubP {
        width: 100%;
        /* overflow-x: scroll; */
        overflow-x: auto;
        overflow-y: hidden;
        /* 超出自定义窄滚动条（4px 高），不用系统默认样式 */
        scrollbar-width: thin;
        scrollbar-color: #c6c6c6 transparent;
    }

    .topSubP::-webkit-scrollbar {
        height: 3px;
        width: 3px;
    }

    .topSubP::-webkit-scrollbar-track {
        background: transparent;
    }

    .topSubP::-webkit-scrollbar-thumb {
        background: #c6c6c6;
        border-radius: 1.5px;
    }

    .topSubP::-webkit-scrollbar-thumb:hover {
        background: #9e9e9e;
    }

    .topSub {
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        /* 窄窗口下宽度按内容撑开，超出部分由 topSubP 横向滚动，不换行 */
        width: max-content;
        min-width: 100%;
    }

    .topLLP {
        margin-left: 16px;
        /* 与右侧头像区的最小间距：
           .topSub 是 space-between，宽窗口下靠剩余空间自然分开；
           但窗口宽度 ≤ 内容宽（425px）时整行转为横向滚动、没有剩余空间，
           不预留就会让最后一个 tab（Skill）和头像贴在一起（间距 0）。 */
        margin-right: 16px;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        flex-shrink: 0;
        /* 宽度必须由内容撑开（不能写死固定值）：
           写死宽度时超出的 tab 只是「画」在盒子外面，不参与 .topSub 的 max-content 计算，
           窄窗口下 .topRP（右上角头像）会盖住末尾的 tab（如 Skill），点击被 topRP 吃掉 → 点了没反应。
           现在 tab 总宽进入布局，窄窗口时超出部分由 .topSubP 横向滚动（见 wheelHScroll）。 */
        width: max-content;
        min-width: max-content;
        /* 长按拖拽排序时避免选中文字 */
        -webkit-user-select: none;
        user-select: none;
    }

    .topLLItem {
        flex-shrink: 0;
        white-space: nowrap;
        cursor: pointer;
    }

    .topLLItemSel {
        color: #FB5D5C;
        font-size: 16px;
    }

    .topLLItemLine {
        width: 1px;
        height: 16px;
        background-color: #BDBDBD;
        margin-left: 8px;
        margin-right: 8px;
        flex-shrink: 0;
    }

    .topLLItem span {
        font-size: 14px;
        font-weight: 500;
    }

    .topLLItem div {
        width: 24px;
        height: 2px;
        border-radius: 2px;
        margin-top: 2px;
        background-color: #FB5D5C;
        margin: auto;
    }

    .topL {
        display: flex;
        align-items: center;
        flex-shrink: 0;
    }

    .topLL {
        width: 20px;
        height: 20px;
        margin-left: 14px;
    }

    .topLR {
        font-size: 14px;
        font-weight: 500;
        color: #3c3c3c;
        margin-left: 8px;
        max-width: 150px;
        height: 32px;
        line-height: 32px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    /* 右上角头像区：宽度只按头像实际尺寸，避免多占的空白盖住末尾的 tab。
       pointer-events:none 是二次兜底：即使将来布局再重叠，这里也不会吞掉 tab 的点击，
       头像本身用 .topRR2 的 pointer-events:auto 保持可点。 */
    .topRP {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-shrink: 0;
        pointer-events: none;
    }

    .topRR2 {
        display: flex;
        flex-shrink: 0;
        pointer-events: auto;
    }

    .topR {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        /*    margin-right: 16px;*/
    }

    .topRL {
        width: 14px;
        height: 15px;
        margin-left: 14px;
    }

    .topRR {
        margin-left: 8px;
        color: #4A90E2;
        font-size: 14px;
        white-space: nowrap;
        /*    padding-right: 20px;*/
        /*    border-right: 1px solid #BDBDBD;*/
    }

    /* 根容器固定为视口大小：文档本身永不滚动，
       高度变化全部由下面的 .content / 列表自己消化 */
    .homePage {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        overflow: hidden;
    }

    .content {
        display: flex;
        box-sizing: border-box;
        /*    padding-top: 83px;*/
        height: 100%;
        padding-top: 125px;
    }

    /* 备忘/剪贴板/技能页签：顶部没有搜索区，只留 83px */
    .contentNoSearchTop {
        padding-top: 83px;
    }

    /* 共享话术页签底部有「添加分类 / 添加话术」操作栏，内容区让出 40px */
    .contentWithBottomBar {
        height: calc(100% - 40px);
    }

    .typeList {
        /*    width: 144px;*/
        min-width: 50px;
        max-width: 200px;
        background-color: #F5F6F6;
        overflow: scroll;
        /* 高度跟随内容区，窗口高度变化时自动重算 */
        height: 100%;
        box-sizing: border-box;
    }

    .typeList::-webkit-scrollbar {
        width: 0px !important;
        height: 0px !important;
    }


    .typeListItem {
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        background-color: #F5F6F6;
        font-size: 14px;
        color: #3C3C3C;
        padding-left: 14px;
    }

    .typeListItem div {
        /*    width: 112px;*/
        width: 90%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }

    .typeListItemSel {
        background-color: #fff;
        color: #FB5D5C;
        font-weight: 500;
    }

    .huashuList {
        /*    width: 77%;*/
        overflow: scroll;
        flex: 1;
        position: relative;
        /* 高度跟随内容区；border-box 让「置顶内容」的 32px 内边距不撑高元素 */
        height: 100%;
        box-sizing: border-box;
    }

    .huashuListItem {
        padding: 8px 8px 8px 0px;
        /* border-bottom: 1px solid #E5E5E5; */
        padding-left: 8px;
        position: relative;
        line-height: 1.2;
    }

    .huashuListItemTop {
        display: flex;
        align-items: center;
    }

    .huashuListItemTopL {
        width: 20px;
        height: 20px;
    }

    .huashuListItemTopM {
        /* margin-left: 4px; */
        /* margin-right: 8px; */
        font-size: 14px;
        line-height: 25px;
        font-weight: 500;
        color: #4A90E2;
        text-overflow: ellipsis;
        overflow: hidden;
        max-width: 90%;
        white-space: nowrap;
    }

    .huashuListItemTopMBig {
        font-size: 16px;
        font-weight: bold;
        margin-left: 0;
    }

    .huashuListItemTopR {
        margin-right: 8px;
        width: 24px;
        height: 24px;
    }

    .actionBtn {
        color: #4A90E2;
        font-size: 14px;
    }

    .huashuListItemDetailP {
        /* border-bottom: 1px solid #E5E5E5; */
        padding-bottom: 16px;
    }

    .huashuListItemDetail {
        font-size: 13px;
        white-space: pre-wrap;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        line-height: 20px;
        min-height: 20px;
    }

    .huashuListItemDetailShowmore {
        margin-top: 4px;
        font-size: 14px;
        white-space: pre-wrap;
    }

    .huashuListItemDetailNoHide {
        margin-top: 4px;
        font-size: 14px;
        white-space: pre-wrap;
        position: absolute;
        /*left: -10000px;
    bottom: -10000px;*/
        left: 0;
        top: 0;
        opacity: 0;
        line-height: 20px;
        pointer-events: none;
    }

    .teamListCover {
        position: absolute;
        top: 79px;
        left: 0;
        width: 100%;
        background-color: #fff;
        border-radius: 0 0 8px 8px;
        box-shadow: 0 4px 8px 0 #e5e5e580;
        z-index: 99999;
    }

    .teamListP {
        display: flex;
        justify-content: center;
    }

    .teamList {
        width: 89.74%;
        display: flex;
        flex-wrap: wrap;
    }

    .teamListItem {
        width: 33%;
        height: 40px;
        border-radius: 4px;
        border: 1px solid #E5E5E5;
        background-color: #F5F6F6;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #3C3C3C;
        font-size: 14px;
        flex-basis: calc(33.33% - 20px);
        /* 让每个子元素等分，这里假设有3个子元素，减去10px的间隔 */
        margin: 10px;
        /* 添加间隔 */
        box-sizing: border-box;
        position: relative;
    }

    .teamListItem img {
        position: absolute;
        left: 0;
        top: 0;
        width: 16px;
        height: 16px;
    }

    .teamListItem div {
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 80%;
        overflow: hidden;
        text-align: center;
    }

    .teamListItemSel {
        border-color: #FB5D5C;
        background-color: #FFF6F6;
        color: #FB5D5C;
    }

    .shouqiBtnP {
        display: flex;
        justify-content: center;
    }

    .shouqiBtn {
        color: #4A90E2;
        font-size: 14px;
        display: flex;
        align-items: center;
        margin: auto;
    }

    .shouqiBtn img {
        width: 14px;
        height: 8px;
        margin-left: 4px;
    }

    /* 销冠键盘页签：与备忘/剪贴板/Skill 页签一致，占满顶部 tab 栏以下的整个内容区，
       自己在内部滚动；不再用浮层，避免切换过来时还露出上一个页签的内容 */
    .xiaoguanPanel {
        flex: 1;
        height: 100%;
        min-width: 0;
        box-sizing: border-box;
        background-color: #fff;
        overflow-y: auto;
        overflow-x: hidden;
        padding-bottom: 24px;
    }

    .xkTopBar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 32px 0;
        flex-wrap: nowrap;
    }

    .xkSegmentBar {
        display: flex;
        padding: 16px 32px 0;
    }

    .xkSegmentTab {
        padding: 6px 20px;
        border-radius: 4px;
        background: #F5F6F6;
        color: #3C3C3C;
        font-size: 14px;
        cursor: pointer;
        margin-right: 12px;
    }

    .xkSegmentTabSel {
        background: #FB5D5C;
        color: #fff;
    }

    .xkInputP {
        width: 55%;
        display: flex;
        align-items: center;
    }

    .xkUploadBtn {
        flex-shrink: 0;
        width: 36px;
        height: 36px;
        margin-left: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #E5E5E5;
        border-radius: 4px;
        background-color: #F5F6F6;
        color: #3C3C3C;
        cursor: pointer;
        box-sizing: border-box;
    }

    .xkUploadBtn:hover {
        border-color: #FB5D5C;
        color: #FB5D5C;
    }

    .xkUploadBtn:active {
        background-color: #EBEDED;
    }

    .xkUploadBtnLoading {
        pointer-events: none;
        opacity: 0.6;
    }

    .xkUploadSpinner {
        width: 16px;
        height: 16px;
        border: 2px solid #D8D8D8;
        border-top-color: #FB5D5C;
        border-radius: 50%;
        animation: xkUploadSpin 0.8s linear infinite;
    }

    @keyframes xkUploadSpin {
        to {
            transform: rotate(360deg);
        }
    }

    .xkQuestionInput {
        flex: 1;
        min-width: 0;
    }

    .xkInputHint {
        display: flex;
        align-items: center;
        color: #3C3C3C;
        font-size: 14px;
    }

    .xkInput {
        width: 100%;
        height: 36px;
        border: 1px solid #E5E5E5;
        border-radius: 4px;
        background-color: #F5F6F6;
        padding: 0 12px;
        font-size: 14px;
        color: #3C3C3C;
        outline: none;
        box-sizing: border-box;
    }

    .xkInput::placeholder {
        color: #999999;
    }

    .xkCheckboxP {
        display: flex;
        align-items: center;
        flex-shrink: 0;
    }

    .xkCheckboxItem {
        display: flex;
        align-items: center;
        margin-left: 24px;
        cursor: pointer;
        color: #3C3C3C;
        font-size: 14px;
        max-width: 160px;
    }

    .xkCheckboxItem span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .xkCheckboxItem:hover {
        color: #FB5D5C;
    }

    .xkCheckboxItemSel {
        color: #FB5D5C;
    }

    .xkArrowIcon {
        width: 10px;
        height: 6px;
        margin-left: 4px;
        transform: rotate(180deg);
    }


    .xkCategoryList {
        margin-top: 4px;
        padding-bottom: 8px;
        max-height: calc(100vh - 240px);
        overflow-y: auto;
    }

    .xkCategoryItem {
        width: 30%;
        flex-basis: calc(33.33% - 20px);
        height: 44px;
        position: relative;
    }

    .xkCategoryLoadingText {
        color: #FB5D5C;
        font-size: 12px;
        white-space: nowrap;
    }

    .xkLoadingMask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.2);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10000;
    }

    .xkLoadingCard {
        background: #fff;
        border-radius: 12px;
        padding: 40px 48px;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
    }

    .xkLoadingSpinner {
        width: 36px;
        height: 36px;
        border: 3px solid #F5F6F6;
        border-top-color: #FB5D5C;
        border-radius: 50%;
        animation: xkSpin 0.7s linear infinite;
    }

    @keyframes xkSpin {
        to { transform: rotate(360deg); }
    }

    .xkLoadingText {
        margin-top: 16px;
        color: #3C3C3C;
        font-size: 14px;
    }

    .xkLoadingSub {
        margin-top: 6px;
        color: #999;
        font-size: 12px;
    }

    .xkProductAddBtn {
        display: flex;
        align-items: center;
        color: #4A90E2;
        font-size: 16px;
        margin-bottom: 16px;
        cursor: pointer;
    }

    .xkProductAddBtn img {
        width: 19px;
        height: 19px;
        margin-right: 8px;
    }

    .xkProductAddInputP {
        margin-bottom: 16px;
    }

    .xkProductAddInputP .xkInput {
        width: 100%;
    }

    .xkProductList {
        display: flex;
        flex-direction: column;
    }

    .xkProductEmpty {
        color: #999;
        font-size: 14px;
        text-align: center;
        padding: 40px 0;
    }

    .xkProductItem {
        width: 100%;
        height: 40px;
        border-radius: 4px;
        border: 1px solid #E5E5E5;
        background-color: #F5F6F6;
        display: flex;
        align-items: center;
        padding: 0 12px;
        color: #3C3C3C;
        font-size: 14px;
        margin-bottom: 8px;
        box-sizing: border-box;
        cursor: pointer;
    }

    .xkProductItemSel {
        border-color: #FB5D5C;
        background-color: #FFF6F6;
        color: #FB5D5C;
    }

    .xkProductItem div {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .xkTeamList {
        display: flex;
        flex-wrap: wrap;
    }

    /* 剪贴板“添加到话术”的团队选择弹框 */
    .clipboardTeamTip {
        font-size: 13px;
        color: #909399;
        margin-bottom: 4px;
    }

    .clipboardTeamList {
        display: flex;
        flex-wrap: wrap;
        min-height: 60px;
        max-height: 300px;
        overflow-y: auto;
    }

    .clipboardTeamEmpty {
        width: 100%;
        margin-top: 20px;
        text-align: center;
        font-size: 13px;
        color: #bbb;
    }

    .huashuListItemDetailNoTitle {
        /*    padding-left: 23px;*/
        position: relative;
    }

    /*.huashuListItemDetailNoTitle::before{
    content: "";
    float: left;
    background-image: url("https://imagessl.edujia.com/A-1ed71af7_20230804141713.png");
    background-repeat: no-repeat;
    background-size: 23px 14px;
    width: 23px;
    height: 14px;
}
*/
    .imgTmp {
        width: 24px;
        height: 24px;
        position: absolute;
        left: 0;
        top: 0;
    }

    .header-main-top {
        width: 32px;
        height: 32px;
        border-radius: 32px;
        margin-right: 14px;
        object-fit: cover;
    }

    .bottomBarP{
        width: 100%;
        height: 40px;
        /* overflow-x: scroll; */
        overflow-x: auto;
        overflow-y: hidden;
        z-index: 999;  
        position: absolute;
        left: 0;
        bottom: 0;     
    }

    .bottomBar {
        width: 100%;
        min-width: 320px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: #fff;
    }

    .bottomBarL{
        display: flex;
        align-items: center;
    }

    .addTypeBtn {
        width: 86px;
        height: 40px;
        display: flex;
        align-items: center;
        margin-left: 8px;
    }

    .addTypeBtn img {
        width: 14px;
        height: 14px;
        margin-right: 4px;
    }

    .addTypeBtn div {
        font-size: 14px;
        color: #4A90E2;
        line-height: 16px;
    }

    .addHuashuBtn {
        height: 40px;
        display: flex;
        align-items: center;
    }

    .addHuashuBtn img {
        width: 14px;
        height: 14px;
        margin-right: 4px;
    }

    .addHuashuBtn div {
        font-size: 14px;
        color: #4A90E2;
        line-height: 16px;
    }

    .psLbl {
        /* position: absolute;
        right: 16px;
        top: 12px; */
        font-size: 12px;
        color: #808080;
        line-height: 20px;
        margin-right: 16px;
    }

    .sizeBtn {
        width: 6px;
        border-radius: 7px;
        height: 50px;
        /*    background-color: red;*/
        display: flex;
        justify-content: space-evenly;
        pointer-events: none;
    }

    .sizeBtn div {
        width: 1px;
        height: 50px;
        background-color: lightgray;
    }

    .custom-resizer {
        width: 100%;
    }

    .layout-v>.multipane-resizer {
        width: 14px;
        height: 100%;
        margin-left: 0px;
        left: 0px;
        cursor: col-resize;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 10px;
        background-color: #fff;
        /*    border-left: 1px solid #eee;
    border-right: 1px solid #eee;*/
    }

    .searchArea {
        margin-top: 8px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-width: 150px;
    }

    /* 左半边：搜索框 + 搜索按钮 */
    .searchAreaLeft {
        width: 50%;
        min-width: 0;
        display: flex;
        align-items: center;
    }

    /* 右半边：当前团队 + 切换团队（从顶部栏下移过来） */
    .searchAreaTeam {
        width: 50%;
        min-width: 0;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        /* 右边距与顶部头像的 margin-right 对齐 */
        padding-right: 14px;
        overflow: hidden;
    }

    .searchAreaTeam .topL {
        min-width: 0;
        /* 窄窗口下允许团队名截断，避免把“切换团队”挤出可视区 */
        flex-shrink: 1;
    }

    .searchAreaTeam .topLL {
        margin-left: 0;
    }

    /* 文案库：文案包切换单独一行，靠右显示 */
    .themeSwitchRow {
        margin-top: 8px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        /* 与顶部头像的 margin-right 对齐 */
        padding-right: 14px;
        overflow: hidden;
    }

    .themeSwitchRow .topL {
        min-width: 0;
        flex-shrink: 1;
    }

    .searchAreaBar {
        flex: 1;
        width: auto;
        min-width: 0;
        height: 32px;
        background-color: #F5F6F6;
        display: flex;
        align-items: center;
        margin-left: 16px;
        margin-right: 8px;
        border-radius: 4px;
    }

    .searchAreaBar img {
        width: 14px;
        height: 14px;
        margin-left: 12px;
        margin-right: 8px;
        flex-shrink: 0;
    }

    .searchAreaBar input {
        flex: 1;
        min-width: 0;
        width: auto;
        padding-right: 12px;
        height: 18px;
        border: none;
        font-size: 13px;
        background-color: transparent;
    }

    .searchAreaBtn {
        width: 88px;
        height: 32px;
        flex-shrink: 0;
        background-color: #FB5D5C;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 13px;
        border-radius: 4px;
        margin-right: 16px;
    }

    .searchAreaCancelBtn {
        border: 1px solid #FB5D5C;
        background-color: #FFF6F6;
        color: #FB5D5C;
    }

    .importHuashuBtn {
        height: 40px;
        display: flex;
        align-items: center;
        color: #4A90E2;
        font-size: 14px;
    }

    .importHuashuBtn img {
        width: 14px;
        height: 14px;
        margin-right: 4px;
        margin-left: 16px;
    }

    .topBar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 32px;
        background-color: #EEEEEE;
        position: absolute;
        top: 0;
        width: 100%;
        left: 0;
        z-index: 999;
        /* box-shadow:1px 1px 5px 1px #dedede; */
    }

    .topBarL {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #3C3C3C;
        font-size: 13px;
        white-space: nowrap;
    }

    .topBarL img {
        width: 14px;
        height: 14px;
        margin-left: 9px;
        margin-right: 8px;
    }

    .topBarR {
        width: 15px;
        height: 14px;
        margin-right: 15px;
    }

    .chooseHuashuTypeList {
        max-height: 300px;
        overflow: scroll;
    }

    .searchingBar{
        position: absolute;
        left: 0;
        top: 100px;
        display: flex;
        align-items: center;
        margin-top: 20px;
        z-index: 999;
        width: 100%;
        background-color: #fff;
        padding-top: 16px;
    }

    .searchingBarIcon{
        width: 54px;
        height: 22px;
        margin-left: 8px;
        margin-right: 4px;
    }

    .faceBtn{
        margin-right: 8px;
        color: #4A90E2;
        display: flex;
        align-items: center;
    }
    
    .faceBtnlbl{
        margin-left: 6px;
        margin-top: -3px;
    }

    .searchBackBtn{
        width: 25px;
        height: 25px;
        margin-left: 20px;
    }

    .sortTypeDialog {
        border-radius: 8px;
    }

    .sortDialogHeader {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .sortDialogTitle {
        font-size: 16px;
        font-weight: bold;
        color: #3C3C3C;
    }

    .sortDialogSaveBtn {
        background-color: #FB5D5C;
        color: #fff;
        border: none;
        border-radius: 16px;
        padding: 4px 16px;
        font-size: 14px;
        cursor: pointer;
        margin-right: 24px;
    }

    .sortTypeList {
        display: flex;
        flex-wrap: wrap;
    }

    .sortTypeItem {
        width: 33%;
        height: 40px;
        border-radius: 4px;
        border: 1px solid #E5E5E5;
        background-color: #F5F6F6;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #3C3C3C;
        font-size: 14px;
        flex-basis: calc(33.33% - 20px);
        margin: 10px;
        box-sizing: border-box;
        cursor: grab;
    }

    .sortTypeItem div {
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 80%;
        overflow: hidden;
        text-align: center;
    }

    .sortTypeItemDragging {
        border-color: #FB5D5C;
        background-color: #FFF6F6;
        color: #FB5D5C;
        opacity: 0.8;
    }

    .sortTypeItemDragOver {
        border-color: #FB5D5C;
        border-style: dashed;
    }

    .sort-flip-move {
        transition: transform 0.3s ease;
    }

    .sortDialogFooter {
        display: none;
    }
</style>
